import { _ as _extends } from './extends-3e8335ef.esm.js';
import React__default, { useState, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { View, Image as Image$1, Text, TouchableOpacity, StyleSheet, ScrollView, Platform } from 'react-native';
import { u as useTheme } from './useTheme-e658d3b6.esm.js';
import { A as AppDot } from './index-f3ba15fa.esm.js';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { Popable } from 'react-native-popable';
import MarkdownIt from 'markdown-it';
import mermaid from 'mermaid';
import { A as AppAssets } from './index-fa849583.esm.js';
import * as URL$1 from 'url';
import { c as copyToClipboard } from './clipboard-655529d6.esm.js';
import hljs from 'highlight.js';
import zenuml from '@mermaid-js/mermaid-zenuml/dist/mermaid-zenuml.core.mjs';
import { debounce } from 'lodash-es';
import 'three';
import AppToolEmojis from '../AppToolEmojis/dist/toothfairy-shared-ui-AppToolEmojis.esm.js';
import Markdown from 'react-native-markdown-display';

//@ts-nocheck
const isElectron = !!window?.electronAPI;
const AppIcon = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    activeColor,
    color,
    size = 18,
    height = size,
    width = size,
    icon,
    label,
    style,
    labelStyle,
    onPress,
    imageSource,
    isActive,
    isClickable,
    isHoverable,
    imageBorderRadius,
    onLayout,
    justifyHorizontally,
    emoji,
    emojiStyle,
    wrapperStyle,
    accessibilityLabel,
    tooltip,
    popableViewStyle,
    showToRight = true,
    showToLeft = false
  } = _ref;
  const isEmoji = emoji != null;
  const {
    currentTheme
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [isMouseHover, setIsMouseHover] = React__default.useState(false);
  const _style = styleGenerator({
    currentTheme,
    borderRadius: size,
    justifyHorizontally,
    height,
    width
  });
  color = color ? color : currentTheme?.theme?.primary;
  activeColor = activeColor ? activeColor : currentTheme?.theme?.primary;
  const coreImage = /*#__PURE__*/React__default.createElement(View, {
    ref: ref,
    onLayout: onLayout,
    onMouseEnter: () => setIsMouseHover(true),
    onMouseLeave: () => setIsMouseHover(false),
    style: [_style.iconImage, style]
  }, label && showToLeft && /*#__PURE__*/React__default.createElement(AppText, {
    style: labelStyle
  }, label), icon && !isEmoji && /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    color: isActive || isHoverable && isMouseHover ? activeColor : color,
    size: size,
    icon: icon,
    accessibilityLabel: accessibilityLabel
  }), imageSource && !isEmoji && (isElectron ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      borderRadius: imageBorderRadius,
      width,
      height,
      objectFit: "contain" // Standard web equivalent of resizeMode
    },
    src: imageSource,
    alt: "" // Add meaningful alt text if possible
  }) : /*#__PURE__*/React__default.createElement(Image$1, {
    style: {
      borderRadius: imageBorderRadius,
      width,
      height,
      resizeMode: "contain"
    },
    source: imageSource
  })), emoji && /*#__PURE__*/React__default.createElement(Text, {
    style: [_style.emoji, emojiStyle]
  }, emoji), label && showToRight && /*#__PURE__*/React__default.createElement(AppText, {
    style: labelStyle
  }, label));
  const poppableImage = tooltip ? /*#__PURE__*/React__default.createElement(Popable, {
    numberOfLines: 2,
    backgroundColor: currentTheme?.theme?.tooltipBackgroundColor,
    style: [{
      top: 40,
      zIndex: 20,
      maxWidth: 300
    }, popableViewStyle],
    content: t(tooltip),
    action: "hover",
    position: "bottom"
  }, coreImage) : coreImage;
  return /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    style: wrapperStyle,
    disabled: !isClickable,
    onPress: onPress
  }, poppableImage);
});
const styleGenerator = _ref2 => {
  let {
    currentTheme,
    size,
    justifyHorizontally,
    height,
    width
  } = _ref2;
  return StyleSheet.create({
    iconImage: {
      width,
      height,
      borderRadius: size,
      alignItems: "center",
      justifyContent: "center",
      flexDirection: justifyHorizontally ? "row" : "column",
      flex: 1
    },
    emoji: {
      color: currentTheme?.theme?.primary,
      fontSize: size
    }
  });
};
AppIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppIcon",
  "props": {
    "size": {
      "defaultValue": {
        "value": "18",
        "computed": false
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "size",
        "computed": true
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "size",
        "computed": true
      },
      "required": false
    },
    "showToRight": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "showToLeft": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

function LinkPreview(_ref) {
  let {
    url
  } = _ref;
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const {
    currentTheme,
    mode
  } = useTheme();
  // create a function to extract the domain from the url including http or https
  function extractDomain(urlString) {
    if (!urlString) {
      return "";
    }
    const urlObj = URL$1.parse(urlString);
    return urlObj.protocol + "//" + urlObj.host;
  }

  // create a function that checks if previewData.image starts with a slash, append the domain to it
  const appendDomain = (url, image) => {
    if (image?.startsWith("/")) {
      const domain = extractDomain(url);
      return `${domain}${image}`;
    }
    return image;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const data = await response.text();
        const isYouTubeVideo = isYouTubeURL(url);
        if (isYouTubeVideo) {
          const videoId = extractYouTubeVideoId(url);
          const videoThumbnail = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
          setPreviewData({
            videoId,
            videoThumbnail
          });
          setLoading(false);
        } else {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, "text/html");
          const title = doc.querySelector("title")?.textContent || "";
          const description = doc.querySelector('meta[name="description"]')?.getAttribute("content") || "";
          const image = doc.querySelector('meta[property="og:image"]')?.getAttribute("content") || "";
          setPreviewData({
            title,
            description,
            image
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    // ensure url does not have toothfairyai.com or toothfairylab.link in it
    if (!url?.includes("toothfairyai.com") && !url?.includes("toothfairylab.link") && !url?.includes("files-to-import-") && !url?.includes("http://")) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [url]);
  const isYouTubeURL = url => {
    return url.includes("youtube.com") || url.includes("youtu.be");
  };
  const extractYouTubeVideoId = url => {
    const videoIdRegex = /(?:\/embed\/|\/watch\?v=|\/(?:embed\/|v\/|watch\?.*v=|youtu\.be\/|embed\/|v=))([^&?#]+)/;
    const match = url.match(videoIdRegex);
    return match ? match[1] : "";
  };
  if (loading) {
    return /*#__PURE__*/React__default.createElement(AppText, {
      style: {
        fontSize: 12
      }
    }, "Loading...");
  }
  if (!previewData) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null)
    // <AppText
    //   style={{
    //     fontSize: 12,
    //   }}
    // >
    //   Failed to fetch link preview
    // </AppText>
    ;
  }
  const handleClick = () => {
    window.open(url, "_blank");
  };
  if (previewData.videoId) {
    return /*#__PURE__*/React__default.createElement("div", {
      onClick: handleClick,
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: previewData.videoThumbnail,
      alt: "Video Thumbnail"
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: handleClick,
    style: {
      cursor: "pointer",
      width: 300,
      margin: 5,
      border: `1px solid ${currentTheme?.theme?.border_color}`,
      padding: 5,
      borderRadius: 5
    }
  }, /*#__PURE__*/React__default.createElement(AppText, {
    style: {
      fontSize: 12
    },
    fontWeight: "bold"
  }, previewData.title), /*#__PURE__*/React__default.createElement(AppText, {
    style: {
      fontSize: 12
    }
  }, previewData.description), previewData.image && /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: 300
    },
    src: appendDomain(url, previewData?.image),
    alt: "Link Preview"
  }));
}
LinkPreview.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LinkPreview"
};

/**
 * Utilities to prepare agent message text for text-to-speech.
 *
 * The goal: only read out loud what the user "fully sees" as prose.
 * Sections wrapped in special XML-ish tags (reasoning, tool callouts,
 * browser sessions, etc.) are rendered as collapsed UI callouts by
 * MarkdownRenderer, so their content must never reach the TTS engine.
 * Code blocks, tables and image markdown are also stripped; links are
 * reduced to their visible label.
 */

// Single source of truth: all special section tag names parsed by
// MarkdownRenderer (mirror of its tagPatterns list).
const SPEECH_SECTION_TAG_NAMES = ["deep_search", "think", "browser", "code_interpreter", "deep_rag", "folder_access", "citations", "mcp", "plan", "user_feedback", "internet_search", "deep_internet_search", "tf_tool_calling", "use_tool", "browser_session", "desktop_session", "parallel_tools", "knowledge_hub", "deep_knowledge_hub", "web_search", "deep_web_search", "code_execution", "file_operations", "file_inventory", "plan_update", "plan_revision", "agent_delegation", "image_generation", "video_generation", "audio_generation", "model_3d_generation", "canvas_generation", "image_analysis", "video_analysis", "audio_analysis", "user_interaction", "skill_activation", "memory_extraction", "memory_recall", "chat_history_search", "compaction"];
const escapeRegExp = s => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const TAGS = SPEECH_SECTION_TAG_NAMES.map(escapeRegExp).join("|");

// <tag>, <tag_2.0>, <mcp_toolname>, <plan_3/5>, <citations_12> ...
const OPEN_TAG = new RegExp(`<(?:${TAGS})(?:_[^>]*)?>`, "g");

// </tag>, </tag_2.0>, </mcp_toolname_2.0> ...
const CLOSE_TAG = new RegExp(`<\\/(?:${TAGS})(?:_[^>]*)?>`, "g");

// Complete section: opener ... closer (non-greedy)
const COMPLETE_SECTION = new RegExp(`<(?:${TAGS})(?:_[^>]*)?>[\\s\\S]*?<\\/(?:${TAGS})(?:_[^>]*)?>`, "g");

// Streaming case: an opener with no closer afterwards swallows the tail
const UNCLOSED_SECTION_TAIL = new RegExp(`<(?:${TAGS})(?:_[^>]*)?>[\\s\\S]*$`, "g");
const FENCED_CODE = /```[\s\S]*?```/g;
const UNCLOSED_FENCED_CODE = /```[\s\S]*$/g;
const TABLE_ROW = /^[^\S\n]*\|.*\|[^\S\n]*$/gm;
const IMAGE_MARKDOWN = /!\[([^\]]*)\]\([^)]*\)/g;
const LINK_MARKDOWN = /\[([^\]]+)\]\([^)]*\)/g;
const STREAMING_CURSOR = /[\u26AB\u26AA]/g;
const MULTI_SPACE = /[ \t]{2,}/g;
const MULTI_NEWLINE = /\n{3,}/g;

/**
 * Strip everything that should not be read out loud from an agent
 * message, leaving only the prose the user fully sees.
 * @param {string} text - raw/processed markdown message text
 * @returns {string} clean speech-ready text
 */
const stripForSpeech = text => {
  if (!text || typeof text !== "string") return "";
  let out = text;

  // 1. Special tagged sections (complete pairs first, then a trailing
  //    unterminated section from streaming, then orphan tags)
  out = out.replace(COMPLETE_SECTION, "\n");
  out = out.replace(UNCLOSED_SECTION_TAIL, "\n");
  out = out.replace(OPEN_TAG, "\n");
  out = out.replace(CLOSE_TAG, "\n");

  // 2. Code blocks (complete, then unterminated while streaming)
  out = out.replace(FENCED_CODE, "\n");
  out = out.replace(UNCLOSED_FENCED_CODE, "\n");

  // 3. Tables
  out = out.replace(TABLE_ROW, "\n");

  // 4. Images (keep meaningful alt text when present)
  out = out.replace(IMAGE_MARKDOWN, (match, alt) => alt && alt.trim() && alt.trim() !== "tf_image" ? ` ${alt.trim()} ` : "\n");

  // 5. Links -> keep only the visible label
  out = out.replace(LINK_MARKDOWN, "$1");

  // 6. Streaming cursor symbols
  out = out.replace(STREAMING_CURSOR, "");

  // 7. Collapse the whitespace left behind
  out = out.replace(MULTI_SPACE, " ").replace(MULTI_NEWLINE, "\n\n").trim();
  return out;
};

// Helper to get messages for a given status
const getMessagesForStatus = (status, t) => {
  const statusMessages = {
    analyze_in_progress: t("chats.typing.analyze_in_progress", {
      returnObjects: true
    }),
    reasoning_in_progress: t("chats.typing.reasoning_in_progress", {
      returnObjects: true
    }),
    image_analysis_in_progress: t("chats.typing.image_analysis_in_progress", {
      returnObjects: true
    }),
    video_analysis_in_progress: t("chats.typing.video_analysis_in_progress", {
      returnObjects: true
    }),
    audio_analysis_in_progress: t("chats.typing.audio_analysis_in_progress", {
      returnObjects: true
    }),
    domain_knowledge_retrieval: t("chats.typing.domain_knowledge_retrieval", {
      returnObjects: true
    }),
    agent_functions_processing: t("chats.typing.agent_functions_processing", {
      returnObjects: true
    }),
    image_generation_in_progress: t("chats.typing.image_generation_in_progress", {
      returnObjects: true
    }),
    image_adaptation_in_progress: t("chats.typing.image_adaptation_in_progress", {
      returnObjects: true
    }),
    video_generation_in_progress: t("chats.typing.video_generation_in_progress", {
      returnObjects: true
    }),
    "3d_model_generation_in_progress": t("chats.typing.3d_model_generation_in_progress", {
      returnObjects: true
    }),
    internet_search_in_progress: t("chats.typing.internet_search_in_progress", {
      returnObjects: true
    }),
    deep_internet_search_in_progress: t("chats.typing.deep_internet_search_in_progress", {
      returnObjects: true
    }),
    code_generation_in_progress: t("chats.typing.code_generation_in_progress", {
      returnObjects: true
    }),
    code_execution_in_progress: t("chats.typing.code_execution_in_progress", {
      returnObjects: true
    }),
    canvas_generation_in_progress: t("chats.typing.canvas_generation_in_progress", {
      returnObjects: true
    }),
    canvas_execution_in_progress: t("chats.typing.canvas_execution_in_progress", {
      returnObjects: true
    }),
    external_messages_setup_in_progress: t("chats.typing.external_messages_setup_in_progress", {
      returnObjects: true
    }),
    scheduling_setup_in_progress: t("chats.typing.scheduling_setup_in_progress", {
      returnObjects: true
    }),
    agent_delegation_in_progress: t("chats.typing.agent_delegation_in_progress", {
      returnObjects: true
    }),
    browser_session_in_progress: t("chats.typing.browser_session_in_progress", {
      returnObjects: true
    }),
    data_processing_completed: t("chats.typing.data_processing_completed", {
      returnObjects: true
    }),
    tools_processing_completed: t("chats.typing.tools_processing_completed", {
      returnObjects: true
    }),
    post_task_generating_artifacts: t("chats.typing.post_task_generating_artifacts", {
      returnObjects: true
    }),
    post_task_sending_messages_over_channels: t("chats.typing.post_task_sending_messages_over_channels", {
      returnObjects: true
    }),
    post_task_generating_summaries: t("chats.typing.post_task_generating_summaries", {
      returnObjects: true
    }),
    post_task_executing_callback_functions: t("chats.typing.post_task_executing_callback_functions", {
      returnObjects: true
    }),
    post_task_generating_memories: t("chats.typing.post_task_generating_memories", {
      returnObjects: true
    }),
    post_task_generating_final_report: t("chats.typing.post_task_generating_final_report", {
      returnObjects: true
    }),
    planning_plan: t("chats.typing.planning_plan", {
      returnObjects: true
    }),
    planning_in_progress: t("chats.typing.planning_in_progress", {
      returnObjects: true
    }),
    planning_requires_approval: t("chats.typing.planning_requires_approval", {
      returnObjects: true
    }),
    plan_execution_in_progress: t("chats.typing.plan_execution_in_progress", {
      returnObjects: true
    }),
    step_requires_approval: t("chats.typing.step_requires_approval", {
      returnObjects: true
    }),
    step_requires_desktop: t("chats.typing.step_requires_desktop", {
      returnObjects: true
    }),
    plan_execution_completed: t("chats.typing.plan_execution_completed", {
      returnObjects: true
    }),
    plan_execution_failed: t("chats.typing.plan_execution_failed", {
      returnObjects: true
    }),
    reviewing_output: t("chats.typing.reviewing_output", {
      returnObjects: true
    }),
    replanning: t("chats.typing.replanning", {
      returnObjects: true
    }),
    retrying: t("chats.typing.retrying", {
      returnObjects: true
    }),
    browser_use: t("chats.typing.browser_use", {
      returnObjects: true
    }),
    executing_step: t("chats.typing.executing_step", {
      returnObjects: true
    }),
    deep_thinking: t("chats.typing.deep_thinking", {
      returnObjects: true
    }),
    planning_approved: t("chats.typing.planning_approved", {
      returnObjects: true
    }),
    planning_rejected: t("chats.typing.planning_rejected", {
      returnObjects: true
    }),
    auto_approved: t("chats.typing.auto_approved", {
      returnObjects: true
    }),
    planning_not_available: t("chats.typing.planning_not_available", {
      returnObjects: true
    }),
    adjustment_required: t("chats.typing.adjustment_required", {
      returnObjects: true
    }),
    initial_setup_completed: t("chats.typing.initial_setup_completed", {
      returnObjects: true
    }),
    replying: t("chats.typing.replying", {
      returnObjects: true
    }),
    post_task_wrapping_up: t("chats.typing.post_task_wrapping_up", {
      returnObjects: true
    }),
    post_task_completed: t("chats.typing.post_task_completed", {
      returnObjects: true
    }),
    // Seal + Compaction status
    compaction: t("chats.typing.compaction", {
      returnObjects: true
    })
  };
  if (status && statusMessages[status] && Array.isArray(statusMessages[status])) {
    return statusMessages[status];
  }
  return t("chats.typing.defaultPlaceholders", {
    returnObjects: true
  });
};
const TypingText = _ref => {
  let {
    textToDisplay = "**...**",
    delayInMilliseconds = 10,
    marginLeft,
    noDelay,
    marginTopOffset = -10,
    useRotatingWords = false,
    processing_status = null,
    showOnlyIndicator = false,
    playOnce = false,
    agentColor = null,
    kaleidoscopeSize = 10,
    typingTextWrapperStyle,
    isStreaming = true,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    currentTheme
  } = useTheme();
  const [displayText, setDisplayText] = useState("");
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [hasCompletedOnce, setHasCompletedOnce] = useState(false);
  const [dynamicPlaceholderText, setDynamicPlaceholderText] = useState("");

  // Check if processing_status is a dynamic placeholder (wrapped in **)
  const isDynamicPlaceholder = processing_status && processing_status.startsWith("**") && processing_status.endsWith("**") && processing_status.length > 4;

  // Extract the text from dynamic placeholder (remove ** from start and end)
  const extractedDynamicText = isDynamicPlaceholder ? processing_status.slice(2, -2) : null;

  // Debug logging for dynamic placeholder detection
  // Determine if we should use the rotating words animation
  // When playOnce is true with custom text, don't use rotating words
  // Also skip rotating words when we have a dynamic placeholder
  const shouldUseRotatingWords = !playOnce && !isDynamicPlaceholder && (useRotatingWords || textToDisplay === "**...**" || textToDisplay === "");

  // Inject animations CSS
  useEffect(() => {
    if (!shouldUseRotatingWords && !isDynamicPlaceholder && !playOnce) return;
    const styleId = "typing-text-animations";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        @keyframes kaleidoscope {
          0% {
            border-radius: 20%;
            transform: rotate(0deg) scale(1);
          }
          25% {
            border-radius: 50%;
            transform: rotate(90deg) scale(0.8);
          }
          50% {
            border-radius: 10%;
            transform: rotate(180deg) scale(1.1);
          }
          75% {
            border-radius: 50%;
            transform: rotate(270deg) scale(0.9);
          }
          100% {
            border-radius: 20%;
            transform: rotate(360deg) scale(1);
          }
        }
      `;
      document.head.appendChild(style);
    }
  }, [shouldUseRotatingWords, isDynamicPlaceholder, playOnce]);

  // Simple typing effect for non-rotating mode (not playOnce, not dynamic placeholder)
  useEffect(() => {
    if (shouldUseRotatingWords || playOnce || isDynamicPlaceholder) return;
    const delay = noDelay ? 0 : delayInMilliseconds / textToDisplay.length;
    let timerId;
    for (let i = 0; i <= textToDisplay.length; i++) {
      timerId = setTimeout(() => {
        setDisplayText(textToDisplay.slice(0, i));
      }, i * delay);
    }
    return () => clearTimeout(timerId);
  }, [textToDisplay, shouldUseRotatingWords, noDelay, delayInMilliseconds, playOnce, isDynamicPlaceholder]);

  // Play once typing effect - types out custom text once without looping
  useEffect(() => {
    if (!playOnce || hasCompletedOnce) return;
    const fullText = textToDisplay;
    let charIndex = 0;
    let isCancelled = false;
    setDisplayText("");
    const typingInterval = setInterval(() => {
      if (isCancelled) {
        clearInterval(typingInterval);
        return;
      }
      if (charIndex < fullText.length) {
        setDisplayText(fullText.slice(0, charIndex + 1));
        charIndex++;
      } else {
        clearInterval(typingInterval);
        setHasCompletedOnce(true);
      }
    }, 40);
    return () => {
      isCancelled = true;
      clearInterval(typingInterval);
    };
  }, [playOnce, textToDisplay, hasCompletedOnce]);

  // Dynamic placeholder typing effect - types out the extracted text with "..." appended
  useEffect(() => {
    if (!isDynamicPlaceholder || !extractedDynamicText) return;
    const fullText = extractedDynamicText;
    let charIndex = 0;
    let isCancelled = false;
    setDynamicPlaceholderText("");
    const typingInterval = setInterval(() => {
      if (isCancelled) {
        clearInterval(typingInterval);
        return;
      }
      if (charIndex < fullText.length) {
        setDynamicPlaceholderText(fullText.slice(0, charIndex + 1));
        charIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, 40);
    return () => {
      isCancelled = true;
      clearInterval(typingInterval);
    };
  }, [isDynamicPlaceholder, extractedDynamicText]);

  // Get the appropriate messages based on processing_status
  // Memoize to keep stable array references - prevents the rotating words
  // useEffect from restarting on every render (which would reset the typing animation)
  const currentMessages = useMemo(() => getMessagesForStatus(processing_status, t), [processing_status, t]);

  // Reset placeholder index when status changes
  useEffect(() => {
    setPlaceholderIndex(0);
  }, [processing_status]);

  // Rotating words effect with typing animation
  useEffect(() => {
    if (!shouldUseRotatingWords) return;
    const fullText = currentMessages[placeholderIndex] + "...";
    let charIndex = 0;
    let isCancelled = false;
    setDisplayText("");

    // Type out the full text including "..."
    const typingInterval = setInterval(() => {
      if (isCancelled) {
        clearInterval(typingInterval);
        return;
      }
      if (charIndex < fullText.length) {
        setDisplayText(fullText.slice(0, charIndex + 1));
        charIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, 40);

    // Rotate to next word after typing + pause
    const rotationTimer = setTimeout(() => {
      if (!isCancelled) {
        setPlaceholderIndex(prev => (prev + 1) % currentMessages.length);
      }
    }, fullText.length * 40 + 1500); // typing time + 1.5s pause

    return () => {
      isCancelled = true;
      clearInterval(typingInterval);
      clearTimeout(rotationTimer);
    };
  }, [shouldUseRotatingWords, placeholderIndex, currentMessages]);

  // Render for dynamic placeholder mode (backend-provided status wrapped in **)
  if (isDynamicPlaceholder) {
    const dynamicColor = agentColor || currentTheme?.theme?.primary;
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: marginLeft || 0
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: kaleidoscopeSize + 2,
        height: kaleidoscopeSize + 2,
        marginRight: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: kaleidoscopeSize,
        height: kaleidoscopeSize,
        backgroundColor: dynamicColor,
        animation: isStreaming ? "kaleidoscope 2s ease-in-out infinite" : "none"
      }
    })), /*#__PURE__*/React__default.createElement(AppText, _extends({}, props, {
      wrapperStyle: [{
        marginLeft: 0
      }],
      showCopyButton: false,
      color: dynamicColor,
      style: {
        ...props.style,
        fontWeight: "bold",
        color: dynamicColor
      }
    }), dynamicPlaceholderText));
  }

  // Render for playOnce mode (single typing animation with indicator)
  if (playOnce) {
    const playOnceColor = agentColor || currentTheme?.theme?.primary;
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: marginLeft || 0
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: kaleidoscopeSize + 2,
        height: kaleidoscopeSize + 2,
        marginRight: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: kaleidoscopeSize,
        height: kaleidoscopeSize,
        backgroundColor: playOnceColor,
        animation: isStreaming ? "kaleidoscope 2s ease-in-out infinite" : "none"
      }
    })), /*#__PURE__*/React__default.createElement(AppText, _extends({}, props, {
      wrapperStyle: {
        marginLeft: 0
      },
      showCopyButton: false,
      color: playOnceColor,
      style: {
        ...props.style,
        fontWeight: "bold",
        color: playOnceColor
      }
    }), displayText));
  }

  // Render with animation for rotating words mode
  if (shouldUseRotatingWords) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: marginLeft || 0
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: kaleidoscopeSize + 2,
        height: kaleidoscopeSize + 2,
        marginRight: showOnlyIndicator ? 0 : 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: kaleidoscopeSize,
        height: kaleidoscopeSize,
        backgroundColor: agentColor || currentTheme?.theme?.primary,
        animation: isStreaming ? "kaleidoscope 2s ease-in-out infinite" : "none"
      }
    })), !showOnlyIndicator && /*#__PURE__*/React__default.createElement(AppText, _extends({}, props, {
      wrapperStyle: {
        marginLeft: 0
      },
      showCopyButton: false,
      color: agentColor || currentTheme?.theme?.primary,
      style: {
        ...props.style,
        fontWeight: "bold",
        color: agentColor || currentTheme?.theme?.primary
      }
    }), displayText));
  }

  // Original render for non-rotating mode
  return /*#__PURE__*/React__default.createElement(AppText, _extends({}, props, {
    wrapperStyle: {
      marginLeft
    },
    renderMarkdown: true,
    markdownStyles: {
      marginTop: marginTopOffset
    },
    showCopyButton: false
  }), displayText);
};
TypingText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TypingText",
  "props": {
    "textToDisplay": {
      "defaultValue": {
        "value": "\"**...**\"",
        "computed": false
      },
      "required": false
    },
    "delayInMilliseconds": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "required": false
    },
    "marginTopOffset": {
      "defaultValue": {
        "value": "-10",
        "computed": false
      },
      "required": false
    },
    "useRotatingWords": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "processing_status": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "showOnlyIndicator": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "playOnce": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "agentColor": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "kaleidoscopeSize": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "required": false
    },
    "isStreaming": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

const formatValuePreview = function (value) {
  if (value === null) return "null";
  if (value === undefined) return "undefined";
  if (typeof value === "string") {
    if (value.length > 80) return `"${value.substring(0, 80)}..."`;
    return `"${value}"`;
  }
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (Array.isArray(value)) return `Array(${value.length})`;
  if (typeof value === "object") return `Object(${Object.keys(value).length} keys)`;
  return String(value);
};
const getValueColor = (value, fontColor) => {
  if (value === null || value === undefined) return "#9ca3af";
  if (typeof value === "string") return "#16a34a";
  if (typeof value === "number") return "#2563eb";
  if (typeof value === "boolean") return "#d97706";
  return fontColor;
};
const JsonNode = _ref => {
  let {
    name,
    value,
    depth,
    themeColors,
    isLast
  } = _ref;
  const [isExpanded, setIsExpanded] = useState(depth < 1);
  const isArray = Array.isArray(value);
  const isObject = value !== null && typeof value === "object" && !isArray;
  const isComplex = isArray || isObject;
  const keyColor = themeColors.primary || "#6366f1";
  const valueColor = getValueColor(value, themeColors.font_color || "#374151");
  const borderColor = themeColors.lightGrey || "#e5e7eb";
  const bgSubtle = themeColors.lightGrey || "#f9fafb";
  const renderPrimitive = () => /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "inline",
      fontFamily: "monospace",
      fontSize: "13px",
      color: valueColor,
      wordBreak: "break-word"
    }
  }, formatValuePreview(value));
  if (!isComplex) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        paddingLeft: depth > 0 ? 16 : 0,
        padding: "2px 0",
        borderLeft: depth > 0 ? `1px solid ${borderColor}40` : "none",
        marginLeft: depth > 0 ? 4 : 0
      }
    }, name !== undefined && /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontFamily: "monospace",
        fontSize: "13px",
        color: keyColor,
        fontWeight: "600",
        marginRight: 6,
        whiteSpace: "nowrap"
      }
    }, name, ":"), renderPrimitive());
  }
  const entries = isArray ? value.map((v, i) => [i, v]) : Object.entries(value);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: depth > 0 ? 16 : 0,
      borderLeft: depth > 0 ? `1px solid ${borderColor}40` : "none",
      marginLeft: depth > 0 ? 4 : 0
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "2px 0",
      cursor: "pointer",
      userSelect: "none"
    },
    onClick: () => setIsExpanded(!isExpanded)
  }, name !== undefined && /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontFamily: "monospace",
      fontSize: "13px",
      color: keyColor,
      fontWeight: "600",
      marginRight: 6,
      whiteSpace: "nowrap"
    }
  }, name, ":"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      fontFamily: "monospace",
      fontSize: "12px",
      color: themeColors.darkGrey || "#6b7280",
      background: bgSubtle,
      padding: "1px 6px",
      borderRadius: 4
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "inline-block",
      width: 10,
      marginRight: 4,
      textAlign: "center",
      fontSize: 10,
      transition: "transform 0.15s",
      transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)"
    }
  }, "\u25B6"), isArray ? `[${value.length}]` : `{${Object.keys(value).length}}`)), isExpanded && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 2
    }
  }, entries.map((_ref2, idx) => {
    let [k, v] = _ref2;
    return /*#__PURE__*/React__default.createElement(JsonNode, {
      key: String(k),
      name: isArray ? undefined : String(k),
      value: v,
      depth: depth + 1,
      themeColors: themeColors,
      isLast: idx === entries.length - 1
    });
  }), entries.length === 0 && /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingLeft: 16,
      fontFamily: "monospace",
      fontSize: "12px",
      color: themeColors.darkGrey || "#9ca3af",
      fontStyle: "italic"
    }
  }, isArray ? "empty array" : "empty object")));
};
const ParamRow = _ref3 => {
  let {
    name,
    value,
    themeColors
  } = _ref3;
  const [isExpanded, setIsExpanded] = useState(false);
  const isComplex = value !== null && typeof value === "object" && (Array.isArray(value) || Object.keys(value).length > 0);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderBottom: `1px solid ${themeColors.lightGrey || "#e5e7eb"}60`,
      padding: "6px 10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      gap: 8
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontFamily: "monospace",
      fontSize: "12px",
      fontWeight: "700",
      color: themeColors.primary || "#6366f1",
      minWidth: 80,
      maxWidth: 200,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      flexShrink: 0
    },
    title: name
  }, name), /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: 1,
      minWidth: 0
    }
  }, isComplex ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      cursor: "pointer",
      userSelect: "none",
      fontFamily: "monospace",
      fontSize: "12px",
      color: themeColors.darkGrey || "#6b7280",
      background: themeColors.lightGrey || "#f9fafb",
      padding: "1px 6px",
      borderRadius: 4
    },
    onClick: () => setIsExpanded(!isExpanded)
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "inline-block",
      width: 10,
      marginRight: 4,
      textAlign: "center",
      fontSize: 10,
      transition: "transform 0.15s",
      transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)"
    }
  }, "\u25B6"), Array.isArray(value) ? `Array(${value.length})` : `Object(${Object.keys(value).length})`), isExpanded && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 4
    }
  }, /*#__PURE__*/React__default.createElement(JsonNode, {
    value: value,
    depth: 0,
    themeColors: themeColors
  }))) : /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontFamily: "monospace",
      fontSize: "13px",
      color: getValueColor(value, themeColors.font_color || "#374151"),
      wordBreak: "break-word"
    }
  }, formatValuePreview(value)))));
};
const ToolCallDetail = _ref4 => {
  let {
    fnDetail,
    themeColors,
    accentColor,
    isStreaming = false
  } = _ref4;
  if (!fnDetail) return null;
  const toolName = fnDetail?.name || "Unknown Tool";
  const toolType = fnDetail?.type;
  const status = fnDetail?.status;
  const description = fnDetail?.description;
  const duration = fnDetail?.duration;
  const timestamp = fnDetail?.timestamp;
  const params = fnDetail?.arguments || fnDetail?.params || fnDetail?.parameters || null;
  const response = fnDetail?.response ?? fnDetail?.output ?? null;
  const borderColor = accentColor || themeColors?.primary || "#6366f1";
  const bgSubtle = themeColors?.lightGrey || "#f9fafb";
  const fontColor = themeColors?.font_color || "#374151";
  const darkGrey = themeColors?.darkGrey || "#6b7280";
  const lightBorder = themeColors?.lightGrey || "#e5e7eb";
  const formatTimestamp = ts => {
    if (!ts) return null;
    try {
      const d = new Date(typeof ts === "number" ? ts : parseInt(ts, 10));
      return d.toLocaleTimeString();
    } catch {
      return null;
    }
  };
  const timeStr = formatTimestamp(timestamp);
  const copyJson = async data => {
    try {
      await copyToClipboard(JSON.stringify(data, null, 2));
    } catch {}
  };
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderRadius: 6,
      overflow: "hidden",
      border: `1px solid ${lightBorder}`,
      background: bgSubtle,
      fontFamily: "normalFont"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 6,
      padding: "8px 10px",
      background: `${borderColor}0d`,
      borderBottom: `1px solid ${lightBorder}`
    }
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets?.icons?.advanced || AppAssets?.icons?.tools,
    color: borderColor,
    size: 12,
    style: {
      marginRight: 2,
      flexShrink: 0
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontFamily: "monospace",
      fontSize: "13px",
      fontWeight: "700",
      color: borderColor,
      wordBreak: "break-all"
    }
  }, toolName), toolType && /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "10px",
      fontWeight: "500",
      color: darkGrey,
      background: `${borderColor}10`,
      padding: "1px 6px",
      borderRadius: 4,
      whiteSpace: "nowrap"
    }
  }, toolType), status && /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "10px",
      fontWeight: "500",
      color: status === "error" || status === "failed" ? "#dc2626" : "#16a34a",
      padding: "1px 6px",
      borderRadius: 4,
      whiteSpace: "nowrap",
      marginLeft: "auto"
    }
  }, status), isStreaming && !status && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "inline-block",
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: borderColor,
      marginLeft: "auto",
      animation: "pulse 1.5s ease-in-out infinite"
    }
  })), description && /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "6px 10px",
      fontSize: "12px",
      color: darkGrey,
      fontStyle: "italic",
      borderBottom: `1px solid ${lightBorder}`
    }
  }, description), params !== null && params !== undefined && /*#__PURE__*/React__default.createElement("div", {
    style: {
      borderBottom: `1px solid ${lightBorder}`
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "6px 10px",
      background: `${borderColor}05`
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "11px",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: darkGrey
    }
  }, "Input Parameters"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "10px",
      color: darkGrey,
      marginLeft: 6,
      opacity: 0.7
    }
  }, typeof params === "object" && !Array.isArray(params) ? `${Object.keys(params).length} params` : Array.isArray(params) ? `${params.length} items` : ""), /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets?.icons?.quickCopy,
    color: darkGrey,
    size: 11,
    style: {
      marginLeft: "auto",
      opacity: 0.6
    },
    isClickable: true,
    onPress: () => copyJson(params)
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxHeight: 300,
      overflowY: "auto"
    }
  }, params !== null && typeof params === "object" && !Array.isArray(params) && Object.keys(params).length > 0 ? Object.entries(params).map(_ref5 => {
    let [k, v] = _ref5;
    return /*#__PURE__*/React__default.createElement(ParamRow, {
      key: k,
      name: k,
      value: v,
      themeColors: themeColors
    });
  }) : params !== null && typeof params === "object" ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: 8
    }
  }, /*#__PURE__*/React__default.createElement(JsonNode, {
    value: params,
    depth: 0,
    themeColors: themeColors
  })) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "6px 10px",
      fontFamily: "monospace",
      fontSize: "13px",
      color: getValueColor(params, fontColor),
      wordBreak: "break-word"
    }
  }, formatValuePreview(params)))), response !== null && response !== undefined && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "6px 10px",
      background: `${borderColor}05`
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "11px",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      color: darkGrey
    }
  }, "Output"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "10px",
      color: darkGrey,
      marginLeft: 6,
      opacity: 0.7
    }
  }, typeof response === "object" && response !== null ? Array.isArray(response) ? `${response.length} items` : `${Object.keys(response).length} fields` : ""), duration != null && /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "10px",
      color: darkGrey,
      marginLeft: 8,
      opacity: 0.7
    }
  }, duration < 1 ? `${duration.toFixed(2)}s` : `${Number(duration.toFixed(2))}s`), timeStr && /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "10px",
      color: darkGrey,
      marginLeft: 8,
      opacity: 0.5
    }
  }, timeStr), /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets?.icons?.quickCopy,
    color: darkGrey,
    size: 11,
    style: {
      marginLeft: "auto",
      opacity: 0.6
    },
    isClickable: true,
    onPress: () => copyJson(response)
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      maxHeight: 400,
      overflowY: "auto",
      padding: 8
    }
  }, /*#__PURE__*/React__default.createElement(JsonNode, {
    value: response,
    depth: 0,
    themeColors: themeColors
  }))));
};
ToolCallDetail.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ToolCallDetail",
  "props": {
    "isStreaming": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};

// Register HCL/Terraform language for syntax highlighting
// Based on https://github.com/highlightjs/highlightjs-terraform
(function () {
  function hljsDefineTerraform(hljs) {
    const NUMBERS = {
      className: "number",
      begin: "\\b\\d+(\\.\\d+)?",
      relevance: 0
    };
    const STRINGS = {
      className: "string",
      begin: '"',
      end: '"',
      contains: [{
        className: "variable",
        begin: "\\${",
        end: "\\}",
        relevance: 9,
        contains: [{
          className: "string",
          begin: '"',
          end: '"'
        }, {
          className: "meta",
          begin: "[A-Za-z_0-9]*\\(",
          end: "\\)",
          contains: [NUMBERS, {
            className: "string",
            begin: '"',
            end: '"',
            contains: [{
              className: "variable",
              begin: "\\${",
              end: "\\}",
              contains: [{
                className: "string",
                begin: '"',
                end: '"',
                contains: [{
                  className: "variable",
                  begin: "\\${",
                  end: "\\}"
                }]
              }, {
                className: "meta",
                begin: "[A-Za-z_0-9]*\\(",
                end: "\\)"
              }]
            }]
          }, "self"]
        }]
      }]
    };
    return {
      aliases: ["tf", "hcl"],
      keywords: "resource variable provider output locals module data terraform",
      literal: "false true null",
      contains: [hljs.COMMENT("\\#", "$"), NUMBERS, STRINGS]
    };
  }
  hljs.registerLanguage("terraform", hljsDefineTerraform);
  hljs.registerLanguage("hcl", hljsDefineTerraform);
  hljs.registerLanguage("tf", hljsDefineTerraform);
})();
const markdownItKatex = require("markdown-it-katex");
var mila = require("markdown-it-link-attributes");
const footnote = require("markdown-it-footnote");
window.viewHTML = function (id) {
  const content = document.getElementById(id + "_code").textContent;
  const newTab = window.open();
  newTab.document.write(content);
  newTab.document.close();
};
window.smartPreview = function (id) {
  const content = document.getElementById(id + "_code").textContent;

  // Check if the HTML content contains Three.js related keywords
  const hasThreeJS = content.includes("THREE.") || content.includes("three.js") || content.includes("three.min.js") || content.includes("WebGLRenderer") || content.includes("Scene()") || content.includes("PerspectiveCamera") || content.includes("BufferGeometry") || content.includes("Mesh(") || content.toLowerCase().includes("canvas") && (content.includes("webgl") || content.includes("3d") || content.includes("render"));
  if (hasThreeJS) {
    // If it contains Three.js code, use the 3D viewer but render the HTML directly
    window.view3DFromHTML(id);
  } else {
    // Otherwise use the regular HTML viewer
    window.viewHTML(id);
  }
};
window.view3DFromHTML = function (id) {
  const content = document.getElementById(id + "_code").textContent;
  const newTab = window.open();

  // Fix common Three.js typos in the content
  let fixedContent = content.replace(/THREE\.Colour/g, "THREE.Color").replace(/colour:/g, "color:").replace(/colour\s*=/g, "color =");

  // For HTML with Three.js, we render the HTML directly but enhance it with better error handling
  const enhancedHTML = fixedContent.includes("<html") ?
  // If it's a full HTML document, inject error handling
  fixedContent.replace("</head>", `
      <style>
        #error-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.8);
          color: white;
          display: none;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          z-index: 10000;
          font-family: monospace;
        }
        #error-details {
          background: #2d2d2d;
          padding: 20px;
          border-radius: 8px;
          max-width: 80%;
          max-height: 80%;
          overflow: auto;
          white-space: pre-wrap;
        }
        #close-error {
          margin-top: 10px;
          padding: 8px 16px;
          background: #ff4444;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
      </style>
      <script>
        window.addEventListener('error', function(e) {
          const errorOverlay = document.getElementById('error-overlay') || createErrorOverlay();
          const errorDetails = document.getElementById('error-details');
          errorDetails.textContent = 'Error: ' + e.message + '\\n\\nFile: ' + e.filename + '\\nLine: ' + e.lineno + '\\nColumn: ' + e.colno + '\\n\\nStack: ' + (e.error ? e.error.stack : 'No stack trace available');
          errorOverlay.style.display = 'flex';
        });
        
        function createErrorOverlay() {
          const overlay = document.createElement('div');
          overlay.id = 'error-overlay';
          overlay.innerHTML = \`
            <div id="error-details"></div>
            <button id="close-error" onclick="this.parentElement.style.display='none'">Close</button>
          \`;
          document.body.appendChild(overlay);
          return overlay;
        }
      </script>
    </head>`) :
  // If it's a partial HTML, wrap it with error handling
  `
    <!DOCTYPE html>
    <html>
    <head>
      <title>3D HTML Preview</title>
      <style>
        body { margin: 0; padding: 0; background: #1a1a1a; font-family: Arial, sans-serif; }
        #controls {
          position: absolute;
          top: 10px;
          left: 10px;
          z-index: 100;
          background: rgba(0,0,0,0.7);
          color: white;
          padding: 10px;
          border-radius: 5px;
          font-size: 12px;
        }
        #error-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.8);
          color: white;
          display: none;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          z-index: 10000;
          font-family: monospace;
        }
        #error-details {
          background: #2d2d2d;
          padding: 20px;
          border-radius: 8px;
          max-width: 80%;
          max-height: 80%;
          overflow: auto;
          white-space: pre-wrap;
        }
        #close-error {
          margin-top: 10px;
          padding: 8px 16px;
          background: #ff4444;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
      </style>
    </head>
    <body>
      <div id="controls" style="display: none;">
        <div>Interactive 3D Content Detected</div>
      </div>
      <div id="error-overlay">
        <div id="error-details"></div>
        <button id="close-error" onclick="this.parentElement.style.display='none'">Close</button>
      </div>
      
      ${fixedContent}
      
      <script>
        window.addEventListener('error', function(e) {
          const errorOverlay = document.getElementById('error-overlay');
          const errorDetails = document.getElementById('error-details');
          errorDetails.textContent = 'Error: ' + e.message + '\\n\\nFile: ' + e.filename + '\\nLine: ' + e.lineno + '\\nColumn: ' + e.colno + '\\n\\nStack: ' + (e.error ? e.error.stack : 'No stack trace available');
          errorOverlay.style.display = 'flex';
        });
        
        // Show controls if Three.js is detected
        if (typeof THREE !== 'undefined') {
          document.getElementById('controls').style.display = 'block';
        }
      </script>
    </body>
    </html>
  `;
  newTab.document.write(enhancedHTML);
  newTab.document.close();
};
window.view3D = function (id) {
  const content = document.getElementById(id + "_code").textContent;
  const newTab = window.open();
  const html3D = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>3D Model Preview</title>
      <style>
        body { 
          margin: 0; 
          padding: 0; 
          overflow: hidden; 
          background: #1a1a1a;
          font-family: Arial, sans-serif;
        }
        #container { 
          width: 100vw; 
          height: 100vh; 
          position: relative;
        }
        #controls {
          position: absolute;
          top: 10px;
          left: 10px;
          z-index: 100;
          background: rgba(0,0,0,0.7);
          color: white;
          padding: 10px;
          border-radius: 5px;
          font-size: 12px;
        }
        #error {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          text-align: center;
          font-size: 16px;
        }
      </style>
    </head>
    <body>
      <div id="container">
        <div id="controls">
          <div>Mouse: Rotate | Scroll: Zoom | Right-click: Pan</div>
        </div>
        <div id="error" style="display: none;">
          <h3>Error rendering 3D model</h3>
          <p>Unable to parse the provided content as a 3D model.</p>
        </div>
      </div>
      
      <script src="https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/controls/OrbitControls.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/STLLoader.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/OBJLoader.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/GLTFLoader.js"></script>
      
      <script>
        try {
          const scene = new THREE.Scene();
          const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
          const renderer = new THREE.WebGLRenderer({ antialias: true });
          
          renderer.setSize(window.innerWidth, window.innerHeight);
          renderer.setClearColor(0x1a1a1a);
          renderer.shadowMap.enabled = true;
          renderer.shadowMap.type = THREE.PCFSoftShadowMap;
          
          document.getElementById('container').appendChild(renderer.domElement);
          
          const controls = new THREE.OrbitControls(camera, renderer.domElement);
          controls.enableDamping = true;
          controls.dampingFactor = 0.05;
          
          // Lighting
          const ambientLight = new THREE.AmbientLight(0x404040, 0.6);
          scene.add(ambientLight);
          
          const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
          directionalLight.position.set(1, 1, 1);
          directionalLight.castShadow = true;
          scene.add(directionalLight);
          
          const pointLight = new THREE.PointLight(0xffffff, 0.5);
          pointLight.position.set(-1, -1, -1);
          scene.add(pointLight);
          
          // Try to parse and render the content
          const content = \`${content.replace(/`/g, "\\`").replace(/\$/g, "\\$")}\`;
          
          // Check if content looks like a 3D model format
          if (content.includes('vertex') || content.includes('face') || content.includes('v ') || content.includes('f ')) {
            // Try to parse as OBJ-like format
            parseAndRender3DContent(content);
          } else {
            // Try to evaluate as JavaScript code that creates Three.js objects
            evaluateThreeJSCode(content);
          }
          
          function parseAndRender3DContent(content) {
            const geometry = new THREE.BufferGeometry();
            const vertices = [];
            const indices = [];
            
            const lines = content.split('\\n');
            const vertexList = [];
            
            for (let line of lines) {
              line = line.trim();
              if (line.startsWith('v ')) {
                const coords = line.split(/\\s+/).slice(1).map(Number);
                if (coords.length >= 3) {
                  vertexList.push(coords[0], coords[1], coords[2]);
                }
              } else if (line.startsWith('f ')) {
                const faceIndices = line.split(/\\s+/).slice(1).map(s => parseInt(s.split('/')[0]) - 1);
                if (faceIndices.length >= 3) {
                  indices.push(faceIndices[0], faceIndices[1], faceIndices[2]);
                  if (faceIndices.length === 4) {
                    indices.push(faceIndices[0], faceIndices[2], faceIndices[3]);
                  }
                }
              }
            }
            
            if (vertexList.length > 0) {
              geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertexList, 3));
              if (indices.length > 0) {
                geometry.setIndex(indices);
              }
              geometry.computeVertexNormals();
              
              const material = new THREE.MeshPhongMaterial({ 
                color: 0x00ff88, 
                shininess: 100,
                wireframe: false
              });
              
              const mesh = new THREE.Mesh(geometry, material);
              mesh.castShadow = true;
              mesh.receiveShadow = true;
              scene.add(mesh);
              
              // Center and scale the object
              const box = new THREE.Box3().setFromObject(mesh);
              const center = box.getCenter(new THREE.Vector3());
              const size = box.getSize(new THREE.Vector3());
              const maxSize = Math.max(size.x, size.y, size.z);
              
              mesh.position.sub(center);
              mesh.scale.multiplyScalar(2 / maxSize);
              
              camera.position.set(3, 3, 3);
              camera.lookAt(0, 0, 0);
            } else {
              throw new Error('No valid geometry found');
            }
          }
          
          function evaluateThreeJSCode(content) {
            // Create a safe environment for Three.js code execution
            const safeContent = content.replace(/import.*?from.*?;/g, '').replace(/export.*?;/g, '');
            
            try {
              // Try to execute the content as Three.js code
              const func = new Function('THREE', 'scene', 'camera', 'renderer', safeContent);
              func(THREE, scene, camera, renderer);
              
              // If no camera position set, set default
              if (camera.position.length() === 0) {
                camera.position.set(3, 3, 3);
                camera.lookAt(0, 0, 0);
              }
            } catch (error) {
              console.error('Error executing Three.js code:', error);
              // Create a simple geometric shape as fallback
              createFallbackGeometry();
            }
          }
          
          function createFallbackGeometry() {
            const geometry = new THREE.BoxGeometry(1, 1, 1);
            const material = new THREE.MeshPhongMaterial({ color: 0x00ff88 });
            const cube = new THREE.Mesh(geometry, material);
            cube.castShadow = true;
            cube.receiveShadow = true;
            scene.add(cube);
            
            camera.position.set(3, 3, 3);
            camera.lookAt(0, 0, 0);
          }
          
          function animate() {
            requestAnimationFrame(animate);
            controls.update();
            renderer.render(scene, camera);
          }
          
          function onWindowResize() {
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(window.innerWidth, window.innerHeight);
          }
          
          window.addEventListener('resize', onWindowResize);
          animate();
          
        } catch (error) {
          console.error('Error initializing 3D viewer:', error);
          document.getElementById('error').style.display = 'block';
        }
      </script>
    </body>
    </html>
  `;
  newTab.document.write(html3D);
  newTab.document.close();
};
const isPostTaskStatus = status => {
  return status && typeof status === "string" && status.startsWith("post_task_") && status != "post_task_completed";
};
const MarkdownRenderer = _ref => {
  let {
    markdownText,
    style,
    showCopyButton,
    S3downloadUrlRequest,
    workspaceid,
    onCopy = () => {},
    copyIconColor,
    renderHTMLinMarkdown = true,
    coder = false,
    customChartingConfig,
    showFeedbackButtons,
    onPositiveFeedbackPress = () => {},
    onNegativeFeedbackPress = () => {},
    isSpeechGettingProcessed = false,
    updateTextForSpeech = () => {},
    showTextToSpeech = false,
    showCodeInExecution = true,
    renderDynamicHTML = true,
    renderHTMLLinkPreview = true,
    hideReasoning = false,
    reasonedFor = null,
    isInWidget = false,
    showToolCallsDetailsInWidget = false,
    suppressCopyButton = false,
    suppressTextToSpeech = false,
    sources = [],
    // Citation sources metadata from API
    onCitationClick = null,
    // Callback when citation is clicked (receives source object)
    showInProgressWithStyle = false,
    // When true, shows TypingText indicator instead of streaming symbols
    processingStatus = null,
    // Processing status for agentic RAG mode - passed to TypingText
    agentColor = null,
    // Agent color for TypingText styling
    useInterleavedReasoning = false,
    fnDetails = [],
    fnDetailsS3 = null,
    toolCallout = null,
    agents = [] // Workspace agents for resolving agent ids (e.g. delegation labels)
  } = _ref;
  // check if markdown text last characters are a message streaming symbol (e.g., \u26AB or \u26AA) and adjust accordingly.
  const [isMessageStreaming, setIsMessageStreaming] = useState(markdownText.endsWith("\u26AB") || markdownText.endsWith("\u26AA"));
  const [finalAnswer, setFinalAnswer] = useState("");
  const [restOfContent, setRestOfContent] = useState("");
  const [contentSections, setContentSections] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);
  const [processedImages, setProcessedImages] = useState(new Map());
  const [processedMarkdown, setProcessedMarkdown] = useState(markdownText);
  const [cleanedMarkdown, setCleanedMarkdown] = useState(markdownText);
  // Use state to store the result
  const [hasLongReasoning, setHasLongReasoning] = useState(false);
  const [hasDeepSearch, setHasDeepSearch] = useState(false);
  const [deepSearchContent, setDeepSearchContent] = useState("");
  const [isDeepSearchExpanded, setIsDeepSearchExpanded] = useState(false);
  const toggleDeepSearchExpand = () => setIsDeepSearchExpanded(!isDeepSearchExpanded);
  const [deepSearchStopped, setDeepSearchStopped] = useState(false);
  const [suppressCodeHighlighting, setSuppressCodeHighlighting] = useState(false);
  const [thinkingStopped, setThinkingStopped] = useState(false);
  const [hasBrowser, setHasBrowser] = useState(false);
  const [browserStopped, setBrowserStopped] = useState(false);
  const [hasCodeInterpreter, setHasCodeInterpreter] = useState(false);
  const [codeInterpreterStopped, setCodeInterpreterStopped] = useState(false);
  const [hasDeepRag, setHasDeepRag] = useState(false);
  const [deepRagStopped, setDeepRagStopped] = useState(false);
  const [hasFolderAccess, setHasFolderAccess] = useState(false);
  const [folderAccessStopped, setFolderAccessStopped] = useState(false);
  const [hasCitations, setHasCitations] = useState(false);
  const [citationsStopped, setCitationsStopped] = useState(false);
  const [citationCount, setCitationCount] = useState(0);
  const [hasMcp, setHasMcp] = useState(false);
  const [mcpStopped, setMcpStopped] = useState(false);
  const [hasPlan, setHasPlan] = useState(false);
  const [planStopped, setPlanStopped] = useState(false);
  const [hasUserFeedback, setHasUserFeedback] = useState(false);
  const [userFeedbackStopped, setUserFeedbackStopped] = useState(false);
  const [hasInternetSearch, setHasInternetSearch] = useState(false);
  const [internetSearchStopped, setInternetSearchStopped] = useState(false);
  const [hasDeepInternetSearch, setHasDeepInternetSearch] = useState(false);
  const [deepInternetSearchStopped, setDeepInternetSearchStopped] = useState(false);
  const [hasTfToolCalling, setHasTfToolCalling] = useState(false);
  const [tfToolCallingStopped, setTfToolCallingStopped] = useState(false);
  const [hasUseTool, setHasUseTool] = useState(false);
  const [useToolStopped, setUseToolStopped] = useState(false);
  const [hasBrowserSession, setHasBrowserSession] = useState(false);
  const [browserSessionStopped, setBrowserSessionStopped] = useState(false);
  const [hasDesktopSession, setHasDesktopSession] = useState(false);
  const [desktopSessionStopped, setDesktopSessionStopped] = useState(false);
  const [hasParallelTools, setHasParallelTools] = useState(false);
  const [parallelToolsStopped, setParallelToolsStopped] = useState(false);

  // Interleaved Reasoning Tool Tags
  const [hasKnowledgeHub, setHasKnowledgeHub] = useState(false);
  const [knowledgeHubStopped, setKnowledgeHubStopped] = useState(false);
  const [hasDeepKnowledgeHub, setHasDeepKnowledgeHub] = useState(false);
  const [deepKnowledgeHubStopped, setDeepKnowledgeHubStopped] = useState(false);
  const [hasWebSearch, setHasWebSearch] = useState(false);
  const [webSearchStopped, setWebSearchStopped] = useState(false);
  const [hasDeepWebSearch, setHasDeepWebSearch] = useState(false);
  const [deepWebSearchStopped, setDeepWebSearchStopped] = useState(false);
  const [hasCodeExecution, setHasCodeExecution] = useState(false);
  const [codeExecutionStopped, setCodeExecutionStopped] = useState(false);
  const [hasFileOperations, setHasFileOperations] = useState(false);
  const [fileOperationsStopped, setFileOperationsStopped] = useState(false);
  const [hasFileInventory, setHasFileInventory] = useState(false);
  const [fileInventoryStopped, setFileInventoryStopped] = useState(false);
  const [hasPlanUpdate, setHasPlanUpdate] = useState(false);
  const [planUpdateStopped, setPlanUpdateStopped] = useState(false);
  const [hasPlanRevision, setHasPlanRevision] = useState(false);
  const [planRevisionStopped, setPlanRevisionStopped] = useState(false);
  const [hasAgentDelegation, setHasAgentDelegation] = useState(false);
  const [agentDelegationStopped, setAgentDelegationStopped] = useState(false);
  const [hasImageGeneration, setHasImageGeneration] = useState(false);
  const [imageGenerationStopped, setImageGenerationStopped] = useState(false);
  const [hasVideoGeneration, setHasVideoGeneration] = useState(false);
  const [videoGenerationStopped, setVideoGenerationStopped] = useState(false);
  const [hasAudioGeneration, setHasAudioGeneration] = useState(false);
  const [audioGenerationStopped, setAudioGenerationStopped] = useState(false);
  const [hasModel3dGeneration, setHasModel3dGeneration] = useState(false);
  const [model3dGenerationStopped, setModel3dGenerationStopped] = useState(false);
  const [hasCanvasGeneration, setHasCanvasGeneration] = useState(false);
  const [canvasGenerationStopped, setCanvasGenerationStopped] = useState(false);
  const [hasImageAnalysis, setHasImageAnalysis] = useState(false);
  const [imageAnalysisStopped, setImageAnalysisStopped] = useState(false);
  const [hasVideoAnalysis, setHasVideoAnalysis] = useState(false);
  const [videoAnalysisStopped, setVideoAnalysisStopped] = useState(false);
  const [hasAudioAnalysis, setHasAudioAnalysis] = useState(false);
  const [audioAnalysisStopped, setAudioAnalysisStopped] = useState(false);
  const [hasUserInteraction, setHasUserInteraction] = useState(false);
  const [userInteractionStopped, setUserInteractionStopped] = useState(false);
  const [hasSkillActivation, setHasSkillActivation] = useState(false);
  const [skillActivationStopped, setSkillActivationStopped] = useState(false);
  const [hasMemoryExtraction, setHasMemoryExtraction] = useState(false);
  const [memoryExtractionStopped, setMemoryExtractionStopped] = useState(false);
  const [hasMemoryRecall, setHasMemoryRecall] = useState(false);
  const [memoryRecallStopped, setMemoryRecallStopped] = useState(false);
  const [hasChatHistorySearch, setHasChatHistorySearch] = useState(false);
  const [chatHistorySearchStopped, setChatHistorySearchStopped] = useState(false);
  const [hasCompaction, setHasCompaction] = useState(false);
  const [compactionStopped, setCompactionStopped] = useState(false);
  const [activePopover, setActivePopover] = useState(null); // { citationNumber, position }
  const [expandedSections, setExpandedSections] = useState({});
  const popoverRef = useRef(null);
  const containerRef = useRef(null);

  // fnDetails resolution from S3 (async) or inline
  const [s3FnDetails, setS3FnDetails] = useState(null);
  const [isLoadingFnDetails, setIsLoadingFnDetails] = useState(false);

  // Fetch fnDetails from S3 on demand when fnDetailsS3 reference is present
  useEffect(() => {
    const fetchFnDetailsFromS3 = async () => {
      if (fnDetailsS3?.s3_key && S3downloadUrlRequest && (!fnDetails || fnDetails.length === 0)) {
        setIsLoadingFnDetails(true);
        try {
          const result = await S3downloadUrlRequest({
            filename: fnDetailsS3.s3_key,
            context: "fndetails",
            workspaceid: workspaceid
          });
          if (result?.url) {
            const response = await fetch(result.url);
            const data = await response.json();
            setS3FnDetails(data || []);
          }
        } catch (e) {
          setS3FnDetails([]);
        } finally {
          setIsLoadingFnDetails(false);
        }
      } else {
        setS3FnDetails(null);
      }
    };
    fetchFnDetailsFromS3();
  }, [fnDetailsS3?.s3_key]);

  // Resolved fnDetails: prefer S3-fetched, fallback to inline prop
  const resolvedFnDetails = s3FnDetails || fnDetails || [];

  // Build citation map from sources array
  // RAG sources are indexed first, then web sources
  const buildCitationMap = sourcesArray => {
    const map = new Map();
    if (!sourcesArray || sourcesArray.length === 0) return map;
    const ragSources = sourcesArray.filter(s => !s.type || s.type !== "web");
    const webSources = sourcesArray.filter(s => s.type === "web");
    let index = 1;
    for (const source of ragSources) {
      map.set(index++, source);
    }
    for (const source of webSources) {
      map.set(index++, source);
    }
    return map;
  };
  const citationMap = buildCitationMap(sources);

  // Handle citation click
  const handleCitationClick = (event, citationNumber) => {
    event.preventDefault();
    event.stopPropagation();
    const source = citationMap.get(citationNumber);
    if (!source) return;

    // If onCitationClick callback is provided, use it
    if (onCitationClick) {
      onCitationClick(source, citationNumber);
      return;
    }

    // Otherwise show popover
    const rect = event.target.getBoundingClientRect();
    setActivePopover({
      citationNumber,
      source,
      position: {
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX
      }
    });
  };

  // Close popover when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setActivePopover(null);
      }
    };
    if (activePopover) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [activePopover]);

  // Setup click handlers for citation badges rendered by markdown-it-footnote (if any)
  useEffect(() => {
    if (!containerRef.current || citationMap.size === 0) return;

    // Find all footnote reference links (rendered by markdown-it-footnote)
    const footnoteRefs = containerRef.current.querySelectorAll("sup.footnote-ref a, a.footnote-ref");
    footnoteRefs.forEach(ref => {
      // Extract citation number from href (e.g., "#fn1" -> 1)
      const href = ref.getAttribute("href") || "";
      const match = href.match(/#fn(\d+)/);
      if (!match) return;
      const citationNumber = parseInt(match[1], 10);
      const source = citationMap.get(citationNumber);
      if (source) {
        // Convert to anchor link that scrolls to citation
        ref.className = "citation-inline";
        ref.setAttribute("href", `#citation-ref-${citationNumber}`);
        ref.textContent = `(${citationNumber})`;
      }
    });
  }, [processedMarkdown, citationMap, sources]);
  const [isActionVisible, setIsActionVisible] = React__default.useState(false);
  const {
    currentTheme,
    mode
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [isValid, setIsValid] = React__default.useState(false);
  // Add the CSS in your component
  const markdownStyle = {
    ...style
  };
  const getReasoningText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (!useInterleavedReasoning && (isMessageStreaming || !thinkingStopped)) {
      return t("markdown.reasoning.thinking");
    }
    const duration = sectionDuration ?? reasonedFor;
    if (duration != null) {
      const seconds = Number(duration?.toFixed(2)) || 0;
      return t("markdown.reasoning.reasonedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.reasoning.reasoned");
  };
  const getDeepSearchText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !deepSearchStopped) {
      return t("markdown.internetSearch.searching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.internetSearch.searchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.internetSearch.internetSearch");
  };
  const getBrowserText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !browserStopped) {
      return t("markdown.browser.browsing");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.browser.browsedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.browser.browsingLog");
  };
  const getCodeInterpreterText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !codeInterpreterStopped) {
      return t("markdown.codeInterpreter.coding");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.codeInterpreter.codedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.codeInterpreter.code");
  };
  const getDeepRagText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !deepRagStopped) {
      return t("markdown.knowledgeHub.searching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.knowledgeHub.searchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.knowledgeHub.knowledgeHubSearch");
  };
  const getFolderAccessText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !folderAccessStopped) {
      return t("markdown.folderAccess.accessing");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.folderAccess.accessedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.folderAccess.folderAccess");
  };
  const getCitationsText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let sourceCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const count = sourceCount || citationCount;
    if (isMessageStreaming && !citationsStopped) {
      return t("markdown.citations.gathering");
    }
    if (count > 0) {
      return t("markdown.citations.sourceCount", {
        count
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.citations.gatheredIn", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.citations.citations");
  };
  const getMcpText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let toolName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const displayName = toolName ? toolName.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase()) : t("markdown.mcp.defaultTool");
    if (isMessageStreaming && !mcpStopped) {
      return t("markdown.mcp.running", {
        tool: displayName
      });
    }
    if (sectionDuration != null) {
      const seconds = sectionDuration < 1 ? sectionDuration.toFixed(2) : Number(sectionDuration?.toFixed(2));
      return t("markdown.mcp.toolDuration", {
        tool: displayName,
        seconds
      });
    }
    return displayName;
  };
  const getPlanText = function () {
    let completionRate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const rateText = completionRate ? ` (${completionRate})` : "";
    if (isMessageStreaming && !planStopped) {
      return t("markdown.plan.update", {
        rate: rateText
      });
    }
    return t("markdown.plan.update", {
      rate: rateText
    });
  };
  const getUserFeedbackText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !userFeedbackStopped) {
      return t("markdown.userFeedback.processing");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.userFeedback.duration", {
        seconds
      });
    }
    return t("markdown.userFeedback.userFeedback");
  };
  const getInternetSearchText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !internetSearchStopped) {
      return t("markdown.internetSearch.searching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.internetSearch.searchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.internetSearch.internetSearch");
  };
  const getDeepInternetSearchText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !deepInternetSearchStopped) {
      return t("markdown.deepInternetSearch.deepSearching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.deepInternetSearch.deepSearchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.deepInternetSearch.deepInternetSearch");
  };
  const getTfToolCallingText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !tfToolCallingStopped) {
      return t("markdown.tfToolCalling.calling");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.tfToolCalling.calledIn", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.tfToolCalling.toolsCalled");
  };
  const getUseToolText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !useToolStopped) {
      return t("markdown.useTool.used");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.useTool.usedIn", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.useTool.toolUsed");
  };
  const getBrowserSessionText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (isMessageStreaming && !browserSessionStopped) {
      return t("markdown.browser.browsing");
    }
    if (steps) {
      return t("markdown.browserSession.steps", {
        steps
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.browserSession.duration", {
        seconds
      });
    }
    return t("markdown.browserSession.browserSession");
  };
  const getDesktopSessionText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (isMessageStreaming && !desktopSessionStopped) {
      return t("markdown.desktopSession.controlling");
    }
    if (steps) {
      return t("markdown.desktopSession.steps", {
        steps
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2)) || 0;
      return t("markdown.desktopSession.duration", {
        seconds
      });
    }
    return t("markdown.desktopSession.desktopSession");
  };
  const getParallelToolsText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let toolCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const count = toolCount || 0;
    if (isMessageStreaming && !parallelToolsStopped) {
      return t("markdown.parallelTools.running");
    }
    if (count > 0) {
      return t("markdown.parallelTools.count", {
        count
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.parallelTools.duration", {
        seconds
      });
    }
    return t("markdown.parallelTools.parallelExecution");
  };
  const getKnowledgeHubText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !knowledgeHubStopped) {
      return t("markdown.knowledgeHub.searching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.knowledgeHub.searchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.knowledgeHub.knowledgeHubSearch");
  };
  const getDeepKnowledgeHubText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !deepKnowledgeHubStopped) {
      return t("markdown.deepKnowledgeHub.deepSearching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.deepKnowledgeHub.deepSearchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.deepKnowledgeHub.deepKnowledgeHubSearch");
  };
  const getWebSearchText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !webSearchStopped) {
      return t("markdown.webSearch.searching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.webSearch.searchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.webSearch.webSearch");
  };
  const getDeepWebSearchText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !deepWebSearchStopped) {
      return t("markdown.deepWebSearch.deepSearching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.deepWebSearch.deepSearchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.deepWebSearch.deepWebSearch");
  };
  const getCodeExecutionText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !codeExecutionStopped) {
      return t("markdown.codeExecution.executing");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.codeExecution.executedIn", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.codeExecution.codeExecution");
  };
  const getFileOperationsText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const op = operation || t("markdown.fileOperations.file");
    if (isMessageStreaming && !fileOperationsStopped) {
      return t("markdown.fileOperations.processing", {
        operation: op
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.fileOperations.processedIn", {
        operation: op,
        seconds,
        count: seconds
      });
    }
    return t("markdown.fileOperations.fileOperations");
  };
  const getFileInventoryText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let fileCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const count = fileCount || 0;
    if (isMessageStreaming && !fileInventoryStopped) {
      return t("markdown.fileInventory.listing");
    }
    if (count > 0) {
      return t("markdown.fileInventory.found", {
        count
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.fileInventory.listedIn", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.fileInventory.fileInventory");
  };
  const getPlanUpdateText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let taskName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const task = taskName ? `: ${taskName}` : "";
    if (isMessageStreaming && !planUpdateStopped) {
      return t("markdown.planUpdate.updating", {
        task
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.planUpdate.updated", {
        task,
        seconds
      });
    }
    return t("markdown.planUpdate.planUpdate");
  };
  const getPlanRevisionText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let changes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (isMessageStreaming && !planRevisionStopped) {
      return t("markdown.planRevision.revising");
    }
    if (changes) {
      return t("markdown.planRevision.revised", {
        changes
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.planRevision.duration", {
        seconds
      });
    }
    return t("markdown.planRevision.planRevision");
  };
  const getAgentDelegationText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let agentName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const agent = agentName || t("markdown.agentDelegation.specialist");
    if (isMessageStreaming && !agentDelegationStopped) {
      return t("markdown.agentDelegation.delegating", {
        agent
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.agentDelegation.delegated", {
        agent,
        seconds
      });
    }
    return t("markdown.agentDelegation.agentDelegation");
  };
  const getImageGenerationText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let imageCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const count = imageCount || 1;
    if (isMessageStreaming && !imageGenerationStopped) {
      return t("markdown.imageGeneration.generating");
    }
    if (count > 1) {
      return t("markdown.imageGeneration.generatedMultiple", {
        count
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.imageGeneration.generated", {
        seconds
      });
    }
    return t("markdown.imageGeneration.imageGeneration");
  };
  const getVideoGenerationText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !videoGenerationStopped) {
      return t("markdown.videoGeneration.generating");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.videoGeneration.generated", {
        seconds
      });
    }
    return t("markdown.videoGeneration.videoGeneration");
  };
  const getAudioGenerationText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !audioGenerationStopped) {
      return t("markdown.audioGeneration.generating");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.audioGeneration.generated", {
        seconds
      });
    }
    return t("markdown.audioGeneration.audioGeneration");
  };
  const getModel3dGenerationText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !model3dGenerationStopped) {
      return t("markdown.model3dGeneration.generating");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.model3dGeneration.generated", {
        seconds
      });
    }
    return t("markdown.model3dGeneration.model3dGeneration");
  };
  const getCanvasGenerationText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !canvasGenerationStopped) {
      return t("markdown.canvasGeneration.generating");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.canvasGeneration.generated", {
        seconds
      });
    }
    return t("markdown.canvasGeneration.canvasGeneration");
  };
  const getImageAnalysisText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let imageCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const count = imageCount || 1;
    if (isMessageStreaming && !imageAnalysisStopped) {
      return t("markdown.imageAnalysis.analysing", {
        count
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.imageAnalysis.analysed", {
        count,
        seconds
      });
    }
    return t("markdown.imageAnalysis.imageAnalysis");
  };
  const getVideoAnalysisText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !videoAnalysisStopped) {
      return t("markdown.videoAnalysis.analysing");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.videoAnalysis.analysed", {
        seconds
      });
    }
    return t("markdown.videoAnalysis.videoAnalysis");
  };
  const getAudioAnalysisText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !audioAnalysisStopped) {
      return t("markdown.audioAnalysis.analysing");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.audioAnalysis.analysed", {
        seconds
      });
    }
    return t("markdown.audioAnalysis.audioAnalysis");
  };
  const getUserInteractionText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let question = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (isMessageStreaming && !userInteractionStopped) {
      return t("markdown.userInteraction.asking");
    }
    if (question) {
      const truncated = question.substring(0, 50) + (question.length > 50 ? "..." : "");
      return t("markdown.userInteraction.asked", {
        question: truncated
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.userInteraction.duration", {
        seconds
      });
    }
    return t("markdown.userInteraction.userInteraction");
  };
  const getSkillActivationText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let skillName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const skill = skillName || t("markdown.skillActivation.skill");
    if (isMessageStreaming && !skillActivationStopped) {
      return t("markdown.skillActivation.activating", {
        skill
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.skillActivation.activated", {
        skill,
        seconds
      });
    }
    return t("markdown.skillActivation.skillActivation");
  };
  const getMemoryExtractionText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !memoryExtractionStopped) {
      return t("markdown.memoryExtraction.extracting");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.memoryExtraction.extracted", {
        seconds
      });
    }
    return t("markdown.memoryExtraction.memoryExtraction");
  };
  const getMemoryRecallText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let memoryCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const count = memoryCount || 0;
    if (isMessageStreaming && !memoryRecallStopped) {
      return t("markdown.memoryRecall.recalling");
    }
    if (count > 0) {
      return t("markdown.memoryRecall.recalled", {
        count
      });
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.memoryRecall.duration", {
        seconds
      });
    }
    return t("markdown.memoryRecall.memoryRecall");
  };
  const getChatHistorySearchText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !chatHistorySearchStopped) {
      return t("markdown.chatHistorySearch.searching");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.chatHistorySearch.searchedFor", {
        seconds,
        count: seconds
      });
    }
    return t("markdown.chatHistorySearch.chatHistorySearch");
  };
  const getCompactionText = function () {
    let sectionDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (isMessageStreaming && !compactionStopped) {
      return t("markdown.compaction.compacting");
    }
    if (sectionDuration != null) {
      const seconds = Number(sectionDuration?.toFixed(2));
      return t("markdown.compaction.compactedIn", {
        seconds
      });
    }
    return t("markdown.compaction.compaction");
  };
  const toggleSectionExpand = sectionIndex => {
    setExpandedSections(prev => {
      const currentValue = prev[sectionIndex] === undefined ? false : prev[sectionIndex];
      return {
        ...prev,
        [sectionIndex]: !currentValue
      };
    });
  };

  // Extract tool name from section text
  // Patterns like: "✔️ `tool_name` (...) - success" or "✔️ tool_name (...) - execution"
  const extractToolNameFromText = text => {
    if (!text || typeof text !== "string") return null;
    // Try backtick-quoted name first: `tool_name`
    const backtickMatch = text.match(/`([a-zA-Z0-9_]+)`/);
    if (backtickMatch) return backtickMatch[1];
    // Try after ✔️ or ✅ emoji
    const emojiMatch = text.match(/[✔️✅✓]\s*([a-zA-Z0-9_]+)/);
    if (emojiMatch) return emojiMatch[1];
    // Try first word that looks like a tool name (snake_case)
    const wordMatch = text.match(/([a-z][a-zA-Z0-9_]{2,})/);
    if (wordMatch && wordMatch[1].includes("_")) return wordMatch[1];
    return null;
  };

  // Cognito/Amplify UUID shape (agent ids). We only "attempt" resolution:
  // rewrite when the substring is an EXACT match against a known workspace
  // agent id — anything else (already a label) passes through untouched.
  const AGENT_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const findAgentById = id => (agents || []).find(a => a?.id === id) || null;

  // Streaming callout label: "Delegating to <id>: <task>" → "Delegating to <label>: <task>"
  const resolveDelegationCalloutText = text => {
    if (!text || !agents || agents.length === 0) return text;
    const match = text.match(/^Delegating to ([^:]+)(?::|$)/);
    if (!match) return text;
    const id = match[1].trim();
    if (!AGENT_UUID_REGEX.test(id)) return text;
    const agent = findAgentById(id);
    if (!agent?.label) return text;
    return text.replace(match[1], agent.label);
  };

  // Completed section text: "✔️ `delegate_to_agent` (agent=Real Label) - N chars"
  const extractDelegationAgentLabel = text => {
    if (!text || typeof text !== "string") return null;
    const match = text.match(/\(agent=([^)]+)\)/);
    return match ? match[1].trim() : null;
  };

  // Set of section types that represent tool calls (eligible for fnDetail matching)
  const TOOL_SECTION_TYPES = new Set(["tf_tool_calling", "use_tool", "parallel_tools", "knowledge_hub", "deep_knowledge_hub", "web_search", "deep_web_search", "code_execution", "file_operations", "file_inventory", "browser_session", "desktop_session", "agent_delegation", "image_generation", "video_generation", "audio_generation", "model_3d_generation", "canvas_generation", "image_analysis", "video_analysis", "audio_analysis", "user_interaction", "skill_activation", "memory_extraction", "memory_recall", "chat_history_search", "mcp", "deep_rag", "folder_access", "browser", "code_interpreter", "internet_search", "deep_internet_search", "deep_search"]);

  // Pure function: pre-compute fnDetail matches for all sections (including children)
  // Returns a new array of sections with `matchedFnDetail` attached to each tool section
  const matchFnDetailsToSections = (sections, fnDetails) => {
    if (!fnDetails || fnDetails.length === 0) return sections;
    const matchedFnDetails = new Set();

    // Container types that should not be matched to fnDetails themselves
    const CONTAINER_TYPES = new Set(["parallel_tools", "knowledge_hub", "skill_activation"]);
    const matchSingle = section => {
      const isToolSection = TOOL_SECTION_TYPES.has(section.type) || section.type?.startsWith("mcp_");

      // Skip container types - only their children should be matched
      if (CONTAINER_TYPES.has(section.type)) return section;
      if (!isToolSection) return section;
      let matched = null;
      if (section.type === "code_execution" || section.type === "code_interpreter") {
        const executeCodeFnDetails = fnDetails.filter(fn => fn?.name === "execute_code" && !matchedFnDetails.has(fn));
        if (executeCodeFnDetails.length > 0) {
          matched = executeCodeFnDetails[0];
          matchedFnDetails.add(matched);
        }
      } else if (section.type === "create_plan") {
        const createPlanFnDetails = fnDetails.filter(fn => fn?.name === "create_plan" && !matchedFnDetails.has(fn));
        if (createPlanFnDetails.length > 0) {
          matched = createPlanFnDetails[0];
          matchedFnDetails.add(matched);
        }
      } else {
        const toolName = extractToolNameFromText(section.text);
        if (toolName) {
          const matchingByName = fnDetails.filter(fn => fn?.name === toolName && !matchedFnDetails.has(fn));
          if (matchingByName.length > 0) {
            matched = matchingByName[0];
            matchedFnDetails.add(matched);
          } else {
            const fuzzyMatch = fnDetails.find(fn => fn?.name && !matchedFnDetails.has(fn) && (fn.name.includes(toolName) || toolName.includes(fn.name)));
            if (fuzzyMatch) {
              matched = fuzzyMatch;
              matchedFnDetails.add(matched);
            }
          }
        }
      }
      return {
        ...section,
        matchedFnDetail: matched
      };
    };
    const matchRecursive = secs => {
      return secs.map(section => {
        const matched = matchSingle(section);
        if (matched.children) {
          matched.children = matchRecursive(matched.children);
        }
        return matched;
      });
    };
    return matchRecursive(sections);
  };
  const getTagConfig = type => {
    const configs = {
      deep_search: {
        openTag: "<deep_search>",
        closeTag: "</deep_search>",
        color: currentTheme?.theme?.primary,
        icon: isMessageStreaming && !deepSearchStopped ? AppAssets?.icons?.web : AppAssets?.icons?.web,
        label: "deep_search",
        getText: duration => getDeepSearchText(duration),
        isStopped: deepSearchStopped
      },
      thinking: {
        openTag: "<think>",
        closeTag: "</think>",
        color: currentTheme?.theme?.orange,
        icon: isMessageStreaming || !thinkingStopped ? AppAssets?.icons?.reasoning : AppAssets?.icons?.thoughts,
        label: "think",
        getText: duration => getReasoningText(duration),
        isStopped: thinkingStopped
      },
      browser: {
        openTag: "<browser>",
        closeTag: "</browser>",
        color: currentTheme?.theme?.green || "#28c552",
        icon: isMessageStreaming && !browserStopped ? AppAssets?.icons?.web : AppAssets?.icons?.web,
        label: "browser",
        getText: duration => getBrowserText(duration),
        isStopped: browserStopped
      },
      code_interpreter: {
        openTag: "<code_interpreter>",
        closeTag: "</code_interpreter>",
        color: "#9333ea",
        // Purple color
        icon: isMessageStreaming && !codeInterpreterStopped ? AppAssets?.icons?.code : AppAssets?.icons?.code,
        label: "code_interpreter",
        getText: duration => getCodeInterpreterText(duration),
        isStopped: codeInterpreterStopped
      },
      deep_rag: {
        openTag: "<deep_rag>",
        closeTag: "</deep_rag>",
        color: "#e91e63",
        // Pink color - different from others
        icon: AppAssets?.icons?.notes,
        label: "deep_rag",
        getText: duration => getDeepRagText(duration),
        isStopped: deepRagStopped
      },
      folder_access: {
        openTag: "<folder_access>",
        closeTag: "</folder_access>",
        color: "#28c552",
        // Green color
        icon: AppAssets?.icons?.folder,
        label: "folder_access",
        getText: duration => getFolderAccessText(duration),
        isStopped: folderAccessStopped
      },
      citations: {
        openTag: "<citations>",
        closeTag: "</citations>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.sources,
        label: "citations",
        getText: (duration, sourceCount) => getCitationsText(duration, sourceCount),
        isStopped: citationsStopped
      },
      mcp: {
        openTag: "<mcp_",
        closeTag: "</mcp_",
        color: "#8b5cf6",
        // Violet/purple color for MCP
        icon: isMessageStreaming && !mcpStopped ? AppAssets?.icons?.network : AppAssets?.icons?.network,
        label: "mcp",
        getText: (duration, toolName) => getMcpText(duration, toolName),
        isStopped: mcpStopped
      },
      plan: {
        openTag: "<plan",
        closeTag: "</plan",
        color: currentTheme?.theme?.darkGrey || "#9ca3af",
        icon: AppAssets?.icons?.plan || AppAssets?.icons?.notes,
        label: "plan",
        getText: (duration, completionRate) => getPlanText(duration, completionRate),
        isStopped: planStopped
      },
      user_feedback: {
        openTag: "<user_feedback>",
        closeTag: "</user_feedback>",
        color: currentTheme?.theme?.font_color || "#374151",
        icon: AppAssets?.icons?.feedback || AppAssets?.icons?.chat,
        label: "user_feedback",
        getText: duration => getUserFeedbackText(duration),
        isStopped: userFeedbackStopped
      },
      internet_search: {
        openTag: "<internet_search>",
        closeTag: "</internet_search>",
        color: currentTheme?.theme?.primary,
        icon: isMessageStreaming && !internetSearchStopped ? AppAssets?.icons?.web : AppAssets?.icons?.web,
        label: "internet_search",
        getText: duration => getInternetSearchText(duration),
        isStopped: internetSearchStopped
      },
      deep_internet_search: {
        openTag: "<deep_internet_search>",
        closeTag: "</deep_internet_search>",
        color: currentTheme?.theme?.primary,
        icon: isMessageStreaming && !deepInternetSearchStopped ? AppAssets?.icons?.web : AppAssets?.icons?.web,
        label: "deep_internet_search",
        getText: duration => getDeepInternetSearchText(duration),
        isStopped: deepInternetSearchStopped
      },
      tf_tool_calling: {
        openTag: "<tf_tool_calling>",
        closeTag: "</tf_tool_calling>",
        color: currentTheme?.theme?.purple,
        icon: isMessageStreaming && !tfToolCallingStopped ? AppAssets?.icons?.advanced : AppAssets?.icons?.advanced,
        label: "tf_tool_calling",
        getText: duration => getTfToolCallingText(duration),
        isStopped: tfToolCallingStopped
      },
      use_tool: {
        openTag: "<use_tool>",
        closeTag: "</use_tool>",
        color: currentTheme?.theme?.purple,
        icon: isMessageStreaming && !useToolStopped ? AppAssets?.icons?.advanced : AppAssets?.icons?.advanced,
        label: "use_tool",
        getText: duration => getUseToolText(duration),
        isStopped: useToolStopped
      },
      browser_session: {
        openTag: "<browser_session>",
        closeTag: "</browser_session>",
        color: currentTheme?.theme?.green || "#28c552",
        icon: isMessageStreaming && !browserSessionStopped ? AppAssets?.icons?.web : AppAssets?.icons?.web,
        label: "browser_session",
        getText: (duration, steps) => getBrowserSessionText(duration, steps),
        isStopped: browserSessionStopped
      },
      desktop_session: {
        openTag: "<desktop_session>",
        closeTag: "</desktop_session>",
        color: currentTheme?.theme?.green || "#28c552",
        icon: isMessageStreaming && !desktopSessionStopped ? AppAssets?.icons?.computerUser : AppAssets?.icons?.computerUser,
        label: "desktop_session",
        getText: (duration, steps) => getDesktopSessionText(duration, steps),
        isStopped: desktopSessionStopped
      },
      parallel_tools: {
        openTag: "<parallel_tools>",
        closeTag: "</parallel_tools>",
        color: currentTheme?.theme?.purple || "#8b5cf6",
        icon: isMessageStreaming && !parallelToolsStopped ? AppAssets?.icons?.advanced : AppAssets?.icons?.advanced,
        label: "parallel_tools",
        getText: (duration, toolCount) => getParallelToolsText(duration, toolCount),
        isStopped: parallelToolsStopped
      },
      // Interleaved Reasoning Tool Tags
      knowledge_hub: {
        openTag: "<knowledge_hub>",
        closeTag: "</knowledge_hub>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.notes,
        label: "knowledge_hub",
        getText: duration => getKnowledgeHubText(duration),
        isStopped: knowledgeHubStopped
      },
      deep_knowledge_hub: {
        openTag: "<deep_knowledge_hub>",
        closeTag: "</deep_knowledge_hub>",
        color: "#e91e63",
        icon: AppAssets?.icons?.collection,
        label: "deep_knowledge_hub",
        getText: duration => getDeepKnowledgeHubText(duration),
        isStopped: deepKnowledgeHubStopped
      },
      web_search: {
        openTag: "<web_search>",
        closeTag: "</web_search>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.web,
        label: "web_search",
        getText: duration => getWebSearchText(duration),
        isStopped: webSearchStopped
      },
      deep_web_search: {
        openTag: "<deep_web_search>",
        closeTag: "</deep_web_search>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.deepSearch,
        label: "deep_web_search",
        getText: duration => getDeepWebSearchText(duration),
        isStopped: deepWebSearchStopped
      },
      code_execution: {
        openTag: "<code_execution>",
        closeTag: "</code_execution>",
        color: "#9333ea",
        icon: AppAssets?.icons?.parser,
        label: "code_execution",
        getText: duration => getCodeExecutionText(duration),
        isStopped: codeExecutionStopped
      },
      file_operations: {
        openTag: "<file_operations>",
        closeTag: "</file_operations>",
        color: "#28c552",
        icon: AppAssets?.icons?.file,
        label: "file_operations",
        getText: (duration, operation) => getFileOperationsText(duration, operation),
        isStopped: fileOperationsStopped
      },
      file_inventory: {
        openTag: "<file_inventory>",
        closeTag: "</file_inventory>",
        color: "#28c552",
        icon: AppAssets?.icons?.files,
        label: "file_inventory",
        getText: (duration, fileCount) => getFileInventoryText(duration, fileCount),
        isStopped: fileInventoryStopped
      },
      plan_update: {
        openTag: "<plan_update>",
        closeTag: "</plan_update>",
        color: currentTheme?.theme?.darkGrey || "#9ca3af",
        icon: AppAssets?.icons?.plan,
        label: "plan_update",
        getText: (duration, taskName) => getPlanUpdateText(duration, taskName),
        isStopped: planUpdateStopped
      },
      plan_revision: {
        openTag: "<plan_revision>",
        closeTag: "</plan_revision>",
        color: currentTheme?.theme?.darkGrey || "#9ca3af",
        icon: AppAssets?.icons?.plan,
        label: "plan_revision",
        getText: (duration, changes) => getPlanRevisionText(duration, changes),
        isStopped: planRevisionStopped
      },
      agent_delegation: {
        openTag: "<agent_delegation>",
        closeTag: "</agent_delegation>",
        color: "#8b5cf6",
        icon: AppAssets?.icons?.taskAgent,
        label: "agent_delegation",
        getText: (duration, agentName) => getAgentDelegationText(duration, agentName),
        isStopped: agentDelegationStopped
      },
      image_generation: {
        openTag: "<image_generation>",
        closeTag: "</image_generation>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.["image-gen"],
        label: "image_generation",
        getText: (duration, imageCount) => getImageGenerationText(duration, imageCount),
        isStopped: imageGenerationStopped
      },
      video_generation: {
        openTag: "<video_generation>",
        closeTag: "</video_generation>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.["video-gen"],
        label: "video_generation",
        getText: duration => getVideoGenerationText(duration),
        isStopped: videoGenerationStopped
      },
      audio_generation: {
        openTag: "<audio_generation>",
        closeTag: "</audio_generation>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.audio,
        label: "audio_generation",
        getText: duration => getAudioGenerationText(duration),
        isStopped: audioGenerationStopped
      },
      model_3d_generation: {
        openTag: "<model_3d_generation>",
        closeTag: "</model_3d_generation>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.model3d,
        label: "model_3d_generation",
        getText: duration => getModel3dGenerationText(duration),
        isStopped: model3dGenerationStopped
      },
      canvas_generation: {
        openTag: "<canvas_generation>",
        closeTag: "</canvas_generation>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.canvas,
        label: "canvas_generation",
        getText: duration => getCanvasGenerationText(duration),
        isStopped: canvasGenerationStopped
      },
      image_analysis: {
        openTag: "<image_analysis>",
        closeTag: "</image_analysis>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.advancedImage,
        label: "image_analysis",
        getText: (duration, imageCount) => getImageAnalysisText(duration, imageCount),
        isStopped: imageAnalysisStopped
      },
      video_analysis: {
        openTag: "<video_analysis>",
        closeTag: "</video_analysis>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.fileVideo,
        label: "video_analysis",
        getText: duration => getVideoAnalysisText(duration),
        isStopped: videoAnalysisStopped
      },
      audio_analysis: {
        openTag: "<audio_analysis>",
        closeTag: "</audio_analysis>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.audio,
        label: "audio_analysis",
        getText: duration => getAudioAnalysisText(duration),
        isStopped: audioAnalysisStopped
      },
      user_interaction: {
        openTag: "<user_interaction>",
        closeTag: "</user_interaction>",
        color: currentTheme?.theme?.font_color || "#374151",
        icon: AppAssets?.icons?.question_icon,
        label: "user_interaction",
        getText: (duration, question) => getUserInteractionText(duration, question),
        isStopped: userInteractionStopped
      },
      skill_activation: {
        openTag: "<skill_activation>",
        closeTag: "</skill_activation>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.skill,
        label: "skill_activation",
        getText: (duration, skillName) => getSkillActivationText(duration, skillName),
        isStopped: skillActivationStopped
      },
      memory_extraction: {
        openTag: "<memory_extraction>",
        closeTag: "</memory_extraction>",
        color: currentTheme?.theme?.darkGrey || "#9ca3af",
        icon: AppAssets?.icons?.memory,
        label: "memory_extraction",
        getText: duration => getMemoryExtractionText(duration),
        isStopped: memoryExtractionStopped
      },
      memory_recall: {
        openTag: "<memory_recall>",
        closeTag: "</memory_recall>",
        color: currentTheme?.theme?.darkGrey || "#9ca3af",
        icon: AppAssets?.icons?.memory,
        label: "memory_recall",
        getText: (duration, memoryCount) => getMemoryRecallText(duration, memoryCount),
        isStopped: memoryRecallStopped
      },
      chat_history_search: {
        openTag: "<chat_history_search>",
        closeTag: "</chat_history_search>",
        color: currentTheme?.theme?.primary || "#6366f1",
        icon: AppAssets?.icons?.search,
        label: "chat_history_search",
        getText: duration => getChatHistorySearchText(duration),
        isStopped: chatHistorySearchStopped
      },
      compaction: {
        openTag: "<compaction>",
        closeTag: "</compaction>",
        color: currentTheme?.theme?.darkGrey || "#9ca3af",
        icon: AppAssets?.icons?.summary,
        label: "compaction",
        getText: duration => getCompactionText(duration),
        isStopped: compactionStopped
      }
    };
    // Handle dynamic MCP tag types (e.g., "mcp_search_docs")
    if (type?.startsWith("mcp_")) {
      return {
        ...configs.mcp,
        label: type
      };
    }
    return configs[type] || null;
  };

  // Args-aware callout enrichment (mirrors the tfcode TUI per-tool labels).
  // While a tool tag is open/streaming (section.isComplete === false) and the
  // backend-provided tool_callout matches this section's tag, show the
  // callout label/pending text instead of the generic getText() placeholder.
  // Fully retrocompatible: no toolCallout, a mismatched tag, a completed
  // section, or an empty label all fall back to the existing getText() path.
  const getSectionDisplayText = (section, tagConfig, extraArg) => {
    const baseText = tagConfig.getText(section?.duration, extraArg);
    if (toolCallout && typeof toolCallout === "object" && section && section.isComplete === false && toolCallout.tag === section.type) {
      const calloutText = typeof toolCallout.label === "string" && toolCallout.label.trim() || typeof toolCallout.pending === "string" && toolCallout.pending.trim();
      if (calloutText) {
        // Delegation callouts carry the raw agent_id (uuid) — attempt to
        // resolve it to the agent's name via the workspace agents list.
        if (toolCallout.tag === "agent_delegation") {
          return resolveDelegationCalloutText(calloutText.trim());
        }
        return calloutText.trim();
      }
    }
    return baseText;
  };

  // Inject pulse animation CSS and citation styles
  useEffect(() => {
    const styleId = "agent-mode-animations";
    const primaryColor = currentTheme?.theme?.primary || "#6366f1";
    const greenColor = currentTheme?.theme?.green || "#16a34a";
    const backgroundColor = currentTheme?.theme?.backgroundColor || (mode === "dark" ? "#1f2937" : "#ffffff");
    const borderColor = currentTheme?.theme?.mediumGrey || (mode === "dark" ? "#374151" : "#e5e7eb");
    const fontColor = currentTheme?.theme?.font_color || (mode === "dark" ? "#e5e7eb" : "#1f2937");
    const secondaryFontColor = currentTheme?.theme?.darkGrey || (mode === "dark" ? "#9ca3af" : "#6b7280");
    const lightBackground = currentTheme?.theme?.lightGrey || (mode === "dark" ? "#111827" : "#f9fafb");

    // Create or update the style element
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = `
      @keyframes pulse {
        0%, 100% {
          opacity: 1;
          transform: scale(1);
        }
        50% {
          opacity: 0.5;
          transform: scale(1.2);
        }
      }

      /* Citation badge styles */
      .citation-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 600;
        color: ${primaryColor};
        background: ${primaryColor}1a;
        padding: 1px 5px;
        border-radius: 4px;
        cursor: pointer;
        vertical-align: super;
        transition: all 0.2s ease;
        text-decoration: none;
        margin: 0 1px;
      }

      .citation-badge:hover {
        background: ${primaryColor};
        color: ${currentTheme?.theme?.white || "#ffffff"};
      }

      /* Inline citation styles - superscript (N) format */
      .citation-inline {
        color: ${primaryColor};
        font-size: 0.75em;
        font-weight: 600;
        cursor: pointer;
        padding: 0 2px;
        text-decoration: none;
        vertical-align: super;
      }

      /* Citation popover styles */
      .citation-popover {
        position: fixed;
        z-index: 10000;
        max-width: 400px;
        min-width: 280px;
        background: ${backgroundColor};
        border: 1px solid ${borderColor};
        border-radius: 8px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, ${mode === "dark" ? "0.3" : "0.15"});
        font-family: inherit;
        animation: popoverFadeIn 0.15s ease-out;
        color: ${fontColor};
      }

      @keyframes popoverFadeIn {
        from {
          opacity: 0;
          transform: translateY(-4px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .citation-popover-header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px;
        border-bottom: 1px solid ${borderColor};
      }

      .citation-type-badge {
        font-size: 11px;
        font-weight: 500;
        padding: 2px 8px;
        border-radius: 4px;
        white-space: nowrap;
        margin-right: 5px;
      }

      .citation-type-badge.web {
        background: ${greenColor}1a;
        color: ${greenColor};
      }

      .citation-type-badge.document {
        background: ${primaryColor}1a;
        color: ${primaryColor};
      }

      .citation-popover-title {
        flex: 1;
        font-size: 13px;
        font-weight: 600;
        color: inherit;
        text-decoration: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .citation-popover-title:hover {
        text-decoration: underline;
        color: ${primaryColor};
      }

      .citation-popover-body {
        padding: 12px;
      }

      .citation-passage {
        font-size: 13px;
        line-height: 1.5;
        color: ${secondaryFontColor};
        background: ${lightBackground};
        border-left: 3px solid ${primaryColor};
        padding: 8px 12px;
        margin: 0;
        border-radius: 0 4px 4px 0;
      }

      .truncated-indicator {
        color: ${secondaryFontColor};
        font-size: 12px;
        font-style: italic;
      }

      .citation-popover-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        border-top: 1px solid ${borderColor};
        font-size: 11px;
        color: ${secondaryFontColor};
      }

      .citation-score {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .citation-close-btn {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        cursor: pointer;
        color: ${secondaryFontColor};
        border-radius: 4px;
      }

      .citation-close-btn:hover {
        background: ${lightBackground};
      }
    `;
  }, [currentTheme, mode]);
  const delayedStreamingFeedback = useRef(debounce((markdownText, setIsMessageStreaming) => {
    setIsMessageStreaming(markdownText.endsWith("\u26AB") || markdownText.endsWith("\u26AA"));
  }, 500)).current;
  useEffect(() => {
    delayedStreamingFeedback(markdownText, setIsMessageStreaming);
  }, [markdownText, delayedStreamingFeedback, setIsMessageStreaming]);
  useEffect(() => {
    // Inject pulse animation CSS if agentMode is enabled

    const styleId = "agent-mode-animations";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
              transform: scale(1);
            }
            50% {
              opacity: 0.5;
              transform: scale(1.2);
            }
          }
        `;
      document.head.appendChild(style);
    }
  }, []);
  useEffect(() => {
    // Registering a function on the window object for external access
    window.copyToClipboard = async textOrId => {
      // Handle both string text and element ID (for backward compatibility)
      let textToCopy;
      if (typeof textOrId === "string" && textOrId.length < 20) {
        // Assume it's an element ID (old behavior)
        const codeElement = document.getElementById(`${textOrId}_code`);
        textToCopy = codeElement?.innerText || "";
      } else {
        // Assume it's the actual text to copy
        textToCopy = String(textOrId);
      }
      try {
        // Use the centralized clipboard utility
        const success = await copyToClipboard(textToCopy);
        if (!success) {
          console.log("Failed to copy");
          // send a message to the user that the copy failed
          window?.parent?.postMessage({
            type: "tf_clipboard_iframe",
            message: textToCopy
          }, "*");
        }
        return success;
      } catch (error) {
        console.error("Copy error:", error);
        window?.parent?.postMessage({
          type: "tf_clipboard_iframe",
          message: textToCopy
        }, "*");
        return false;
      }
    };
    return () => {
      delete window.copyToClipboard;
    };
  }, []);
  function extractMermaidCode(input) {
    const startIndicator = "```mermaid";
    const endIndicator = "```";
    const startIndex = input.indexOf(startIndicator);
    const endIndex = input.indexOf(endIndicator, startIndex + startIndicator.length);
    if (startIndex === -1 || endIndex === -1) {
      return input;
    }
    return input.substring(startIndex + startIndicator.length, endIndex).trim();
  }
  useEffect(() => {
    // Find all the elements with the class name 'error-icon'
    const errorText = document.querySelectorAll(".error-text");

    // Loop through the elements
    errorText.forEach((text, index) => {
      if (index === 0) {
        // Replace the content of the first error icon
        text.innerHTML = "";
      } else {
        // Remove the other error icons
        text.innerHTML = "The agent could not produce a valid chart";
      }
    });
  });
  // Define the regex pattern

  // Citation preprocessing function - converts inline [^N] to anchor links that scroll to citations
  const preprocessCitations = markdown => {
    // Clean up the References: header
    let processed = markdown.replace(/References:\s*\n/g, "");

    // Convert inline [^N] references to anchor links that scroll to the citation
    // Match [^N] but NOT at the start of a line (footnote definitions like [^1]: ...)
    processed = processed.replace(/(?<!^)\[\^(\d+)\]/gm, (_match, num) => {
      return `<a class="citation-inline" href="#citation-ref-${num}">(${num})</a>`;
    });
    return processed;
  };
  const processStreamedContent = (content, hideReasoning, isMessageStreaming) => {
    // Check for deep_search, think, browser, code_interpreter, and deep_rag tags
    // All closing tags support optional duration suffix: </tag> or </tag_123>
    if (content?.includes("<deep_search>")) setHasDeepSearch(true);
    if (/<\/deep_search(_[\d.]+)?>/.test(content)) setDeepSearchStopped(true);
    if (content?.includes("<think>")) setHasLongReasoning(true);
    if (/<\/think(_[\d.]+)?>/.test(content)) setThinkingStopped(true);
    if (content?.includes("<browser>")) setHasBrowser(true);
    if (/<\/browser(_[\d.]+)?>/.test(content)) setBrowserStopped(true);
    if (content?.includes("<code_interpreter>")) setHasCodeInterpreter(true);
    if (/<\/code_interpreter(_[\d.]+)?>/.test(content)) setCodeInterpreterStopped(true);
    if (content?.includes("<deep_rag>")) setHasDeepRag(true);
    if (/<\/deep_rag(_[\d.]+)?>/.test(content)) setDeepRagStopped(true);
    if (content?.includes("<folder_access>")) setHasFolderAccess(true);
    if (/<\/folder_access(_[\d.]+)?>/.test(content)) setFolderAccessStopped(true);
    // Citations support both <citations> and <citations_N> format (where N is count)
    const citationsOpenMatch = content?.match(/<citations(?:_(\d+))?>/);
    if (citationsOpenMatch) {
      setHasCitations(true);
      if (citationsOpenMatch[1]) {
        setCitationCount(parseInt(citationsOpenMatch[1], 10));
      }
    }
    if (/<\/citations(_[\d.]+)?>/.test(content)) setCitationsStopped(true);
    // MCP tags: <mcp_{tool_name}>...</mcp_{tool_name}_{duration}>
    if (/<mcp_[^>]+>/.test(content)) setHasMcp(true);
    if (/<\/mcp_[^>]+_[\d.]+>/.test(content)) setMcpStopped(true);
    // Plan tags (supports <plan> or <plan_3/5> format, closing is always </plan>)
    if (/<plan(?:_\d+\/\d+)?>/.test(content)) setHasPlan(true);
    if (content?.includes("</plan>")) setPlanStopped(true);
    // User feedback tags
    if (content?.includes("<user_feedback>")) setHasUserFeedback(true);
    if (/<\/user_feedback(_[\d.]+)?>/.test(content)) setUserFeedbackStopped(true);
    // Internet search tags
    if (content?.includes("<internet_search>")) setHasInternetSearch(true);
    if (/<\/internet_search(_[\d.]+)?>/.test(content)) setInternetSearchStopped(true);
    // Deep Internet search tags
    if (content?.includes("<deep_internet_search>")) setHasDeepInternetSearch(true);
    if (/<\/deep_internet_search(_[\d.]+)?>/.test(content)) setDeepInternetSearchStopped(true);
    // TF Tool Calling tags
    if (content?.includes("<tf_tool_calling>")) setHasTfToolCalling(true);
    if (/<\/tf_tool_calling(_[\d.]+)?>/.test(content)) setTfToolCallingStopped(true);
    // Use Tool tags
    if (content?.includes("<use_tool>")) setHasUseTool(true);
    if (/<\/use_tool(_[\d.]+)?>/.test(content)) setUseToolStopped(true);
    // Browser Session tags
    if (content?.includes("<browser_session>")) setHasBrowserSession(true);
    if (/<\/browser_session(_[\d.]+)?>/.test(content)) setBrowserSessionStopped(true);
    // Desktop Session tags
    if (content?.includes("<desktop_session>")) setHasDesktopSession(true);
    if (/<\/desktop_session(_[\d.]+)?>/.test(content)) setDesktopSessionStopped(true);

    // Parallel Tools
    if (content?.includes("<parallel_tools>")) setHasParallelTools(true);
    if (/<\/parallel_tools(_[\d.]+)?>/.test(content)) setParallelToolsStopped(true);

    // Interleaved Reasoning Tool Tags
    // Knowledge Hub
    if (content?.includes("<knowledge_hub>")) setHasKnowledgeHub(true);
    if (/<\/knowledge_hub(_[\d.]+)?>/.test(content)) setKnowledgeHubStopped(true);
    if (content?.includes("<deep_knowledge_hub>")) setHasDeepKnowledgeHub(true);
    if (/<\/deep_knowledge_hub(_[\d.]+)?>/.test(content)) setDeepKnowledgeHubStopped(true);

    // Web Search
    if (content?.includes("<web_search>")) setHasWebSearch(true);
    if (/<\/web_search(_[\d.]+)?>/.test(content)) setWebSearchStopped(true);
    if (content?.includes("<deep_web_search>")) setHasDeepWebSearch(true);
    if (/<\/deep_web_search(_[\d.]+)?>/.test(content)) setDeepWebSearchStopped(true);

    // Code Execution
    if (content?.includes("<code_execution>")) setHasCodeExecution(true);
    if (/<\/code_execution(_[\d.]+)?>/.test(content)) setCodeExecutionStopped(true);

    // File Operations
    if (content?.includes("<file_operations>")) setHasFileOperations(true);
    if (/<\/file_operations(_[\d.]+)?>/.test(content)) setFileOperationsStopped(true);
    if (content?.includes("<file_inventory>")) setHasFileInventory(true);
    if (/<\/file_inventory(_[\d.]+)?>/.test(content)) setFileInventoryStopped(true);

    // Plan Updates
    if (content?.includes("<plan_update>")) setHasPlanUpdate(true);
    if (/<\/plan_update(_[\d.]+)?>/.test(content)) setPlanUpdateStopped(true);
    if (content?.includes("<plan_revision>")) setHasPlanRevision(true);
    if (/<\/plan_revision(_[\d.]+)?>/.test(content)) setPlanRevisionStopped(true);

    // Agent Delegation
    if (content?.includes("<agent_delegation>")) setHasAgentDelegation(true);
    if (/<\/agent_delegation(_[\d.]+)?>/.test(content)) setAgentDelegationStopped(true);

    // Media Generation
    if (content?.includes("<image_generation>")) setHasImageGeneration(true);
    if (/<\/image_generation(_[\d.]+)?>/.test(content)) setImageGenerationStopped(true);
    if (content?.includes("<video_generation>")) setHasVideoGeneration(true);
    if (/<\/video_generation(_[\d.]+)?>/.test(content)) setVideoGenerationStopped(true);
    if (content?.includes("<audio_generation>")) setHasAudioGeneration(true);
    if (/<\/audio_generation(_[\d.]+)?>/.test(content)) setAudioGenerationStopped(true);
    if (content?.includes("<model_3d_generation>")) setHasModel3dGeneration(true);
    if (/<\/model_3d_generation(_[\d.]+)?>/.test(content)) setModel3dGenerationStopped(true);
    if (content?.includes("<canvas_generation>")) setHasCanvasGeneration(true);
    if (/<\/canvas_generation(_[\d.]+)?>/.test(content)) setCanvasGenerationStopped(true);

    // Media Analysis
    if (content?.includes("<image_analysis>")) setHasImageAnalysis(true);
    if (/<\/image_analysis(_[\d.]+)?>/.test(content)) setImageAnalysisStopped(true);
    if (content?.includes("<video_analysis>")) setHasVideoAnalysis(true);
    if (/<\/video_analysis(_[\d.]+)?>/.test(content)) setVideoAnalysisStopped(true);
    if (content?.includes("<audio_analysis>")) setHasAudioAnalysis(true);
    if (/<\/audio_analysis(_[\d.]+)?>/.test(content)) setAudioAnalysisStopped(true);

    // User Interaction
    if (content?.includes("<user_interaction>")) setHasUserInteraction(true);
    if (/<\/user_interaction(_[\d.]+)?>/.test(content)) setUserInteractionStopped(true);

    // Skills
    if (content?.includes("<skill_activation>")) setHasSkillActivation(true);
    if (/<\/skill_activation(_[\d.]+)?>/.test(content)) setSkillActivationStopped(true);

    // Memory
    if (content?.includes("<memory_extraction>")) setHasMemoryExtraction(true);
    if (/<\/memory_extraction(_[\d.]+)?>/.test(content)) setMemoryExtractionStopped(true);
    if (content?.includes("<memory_recall>")) setHasMemoryRecall(true);
    if (/<\/memory_recall(_[\d.]+)?>/.test(content)) setMemoryRecallStopped(true);
    if (content?.includes("<chat_history_search>")) setHasChatHistorySearch(true);
    if (/<\/chat_history_search(_[\d.]+)?>/.test(content)) setChatHistorySearchStopped(true);
    if (content?.includes("<compaction>")) setHasCompaction(true);
    if (/<\/compaction(_[\d.]+)?>/.test(content)) setCompactionStopped(true);

    // Parse content into ordered sections
    const sections = [];
    let currentIndex = 0;
    const parseSectionsFromContent = function (innerContent) {
      const innerSections = [];
      let innerCurrentIndex = 0;
      while (innerCurrentIndex < innerContent.length) {
        let innerNearestTag = null;
        let innerNearestIndex = innerContent.length;
        let innerOpenTagLength = 0;
        let innerCitationCountFromTag = null;
        let innerMcpToolName = null;
        let innerPlanCompletionRate = null;
        tagPatterns.forEach(pattern => {
          const openIndex = innerContent.indexOf(pattern.open, innerCurrentIndex);
          if (openIndex !== -1 && openIndex < innerNearestIndex) {
            innerNearestIndex = openIndex;
            innerNearestTag = pattern;
            if (pattern.openRegex) {
              const searchContent = innerContent.slice(openIndex);
              const openMatch = searchContent.match(pattern.openRegex);
              if (openMatch) {
                innerOpenTagLength = openMatch[0].length;
                if (pattern.type === "citations" && openMatch[1]) {
                  innerCitationCountFromTag = parseInt(openMatch[1], 10);
                }
                if (pattern.type === "mcp" && openMatch[1]) {
                  innerMcpToolName = openMatch[1];
                }
                if (pattern.type === "plan" && openMatch[1]) {
                  innerPlanCompletionRate = openMatch[1];
                }
              }
            } else {
              innerOpenTagLength = pattern.open.length;
            }
          }
        });
        if (innerNearestIndex > innerCurrentIndex) {
          const textContent = innerContent.slice(innerCurrentIndex, innerNearestIndex).trim();
          if (textContent) {
            innerSections.push({
              type: "content",
              text: textContent
            });
          }
          innerCurrentIndex = innerNearestIndex;
        }
        if (!innerNearestTag) {
          if (innerCurrentIndex < innerContent.length) {
            const remainingContent = innerContent.slice(innerCurrentIndex).trim();
            if (remainingContent) {
              innerSections.push({
                type: "content",
                text: remainingContent
              });
            }
          }
          break;
        }
        const innerActualOpenTagLength = innerOpenTagLength || innerNearestTag.open.length;
        let innerCloseIndex = -1;
        let innerCloseTagLength = innerNearestTag.close.length;
        let innerSectionDuration = null;
        if (innerNearestTag.isDynamic && innerMcpToolName) {
          const escapedToolName = innerMcpToolName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          const mcpCloseRegex = new RegExp(`<\\/mcp_${escapedToolName}_([\\d.]+)>`);
          const searchContent = innerContent.slice(innerNearestIndex + innerActualOpenTagLength);
          const match = searchContent.match(mcpCloseRegex);
          if (match) {
            innerCloseIndex = innerNearestIndex + innerActualOpenTagLength + match.index;
            innerCloseTagLength = match[0].length;
            innerSectionDuration = parseFloat(match[1]);
          }
        } else if (innerNearestTag.closeRegex) {
          const searchContent = innerContent.slice(innerNearestIndex + innerActualOpenTagLength);
          const match = searchContent.match(innerNearestTag.closeRegex);
          if (match) {
            innerCloseIndex = innerNearestIndex + innerActualOpenTagLength + match.index;
            innerCloseTagLength = match[0].length;
            const durationMatch = match[0].match(/_([\d.]+)>/);
            if (durationMatch) {
              innerSectionDuration = parseFloat(durationMatch[1]);
            }
          }
        } else {
          innerCloseIndex = innerContent.indexOf(innerNearestTag.close, innerNearestIndex + innerActualOpenTagLength);
        }
        if (innerCloseIndex !== -1) {
          const tagContent = innerContent.slice(innerNearestIndex + innerActualOpenTagLength, innerCloseIndex).trim();
          if (tagContent) {
            let sectionType = innerNearestTag.type;
            if (innerNearestTag.type === "think") sectionType = "thinking";
            if (innerNearestTag.type === "parallel_tools") sectionType = "parallel_tools";
            const innerSectionData = {
              type: sectionType,
              text: tagContent,
              isComplete: true,
              duration: innerSectionDuration
            };
            if (sectionType === "citations" && innerCitationCountFromTag !== null) {
              innerSectionData.citationCount = innerCitationCountFromTag;
            }
            if (innerNearestTag.type === "mcp" && innerMcpToolName) {
              innerSectionData.mcpToolName = innerMcpToolName;
            }
            if (innerNearestTag.type === "plan" && innerPlanCompletionRate) {
              innerSectionData.planCompletionRate = innerPlanCompletionRate;
            }
            if (innerNearestTag.isWrapper) {
              innerSectionData.children = parseSectionsFromContent(tagContent);
              innerSectionData.toolCount = innerSectionData.children.filter(s => s.type !== "content").length;
            }
            innerSections.push(innerSectionData);
          }
          innerCurrentIndex = innerCloseIndex + innerCloseTagLength;
        } else {
          const tagContent = innerContent.slice(innerNearestIndex + innerActualOpenTagLength).trim();
          let sectionType = innerNearestTag.type;
          if (innerNearestTag.type === "think") sectionType = "thinking";
          if (innerNearestTag.type === "parallel_tools") sectionType = "parallel_tools";
          const innerSectionData = {
            type: sectionType,
            text: tagContent,
            isComplete: false
          };
          if (sectionType === "citations" && innerCitationCountFromTag !== null) {
            innerSectionData.citationCount = innerCitationCountFromTag;
          }
          if (innerNearestTag.type === "mcp" && innerMcpToolName) {
            innerSectionData.mcpToolName = innerMcpToolName;
          }
          if (innerNearestTag.type === "plan" && innerPlanCompletionRate) {
            innerSectionData.planCompletionRate = innerPlanCompletionRate;
          }
          if (innerNearestTag.isWrapper) {
            innerSectionData.children = parseSectionsFromContent(tagContent);
            innerSectionData.toolCount = innerSectionData.children.filter(s => s.type !== "content").length;
          }
          innerSections.push(innerSectionData);
          innerCurrentIndex = innerContent.length;
          break;
        }
      }
      return innerSections;
    };

    // Define tag patterns - expanded to include browser and code_interpreter
    // All tags support optional duration suffix: </tag_123> or </tag_3.92>
    // Tags without duration suffix are still valid for backward compatibility
    const tagPatterns = [{
      type: "deep_search",
      open: "<deep_search>",
      close: "</deep_search>",
      closeRegex: /<\/deep_search(_[\d.]+)?>/
    }, {
      type: "think",
      open: "<think>",
      close: "</think>",
      closeRegex: /<\/think(_[\d.]+)?>/
    }, {
      type: "browser",
      open: "<browser>",
      close: "</browser>",
      closeRegex: /<\/browser(_[\d.]+)?>/
    }, {
      type: "code_interpreter",
      open: "<code_interpreter>",
      close: "</code_interpreter>",
      closeRegex: /<\/code_interpreter(_[\d.]+)?>/
    }, {
      type: "deep_rag",
      open: "<deep_rag>",
      close: "</deep_rag>",
      closeRegex: /<\/deep_rag(_[\d.]+)?>/
    }, {
      type: "folder_access",
      open: "<folder_access>",
      close: "</folder_access>",
      closeRegex: /<\/folder_access(_[\d.]+)?>/
    }, {
      type: "citations",
      open: "<citations",
      // Partial match - will use openRegex for full match
      openRegex: /<citations(?:_(\d+))?>/,
      close: "</citations>",
      closeRegex: /<\/citations(_[\d.]+)?>/
    }, {
      type: "mcp",
      // Dynamic MCP tags: <mcp_{tool_name}>...</mcp_{tool_name}_{duration}>
      open: "<mcp_",
      openRegex: /<mcp_([^>]+)>/,
      // Captures tool name
      close: "</mcp_",
      // Will be dynamically matched with tool name
      isDynamic: true // Flag for special handling
    }, {
      type: "plan",
      open: "<plan",
      openRegex: /<plan(?:_(\d+\/\d+))?>/,
      // Captures completion rate like "3/5"
      close: "</plan>"
    }, {
      type: "user_feedback",
      open: "<user_feedback>",
      close: "</user_feedback>",
      closeRegex: /<\/user_feedback(_[\d.]+)?>/
    }, {
      type: "internet_search",
      open: "<internet_search>",
      close: "</internet_search>",
      closeRegex: /<\/internet_search(_[\d.]+)?>/
    }, {
      type: "deep_internet_search",
      open: "<deep_internet_search>",
      close: "</deep_internet_search>",
      closeRegex: /<\/deep_internet_search(_[\d.]+)?>/
    }, {
      type: "tf_tool_calling",
      open: "<tf_tool_calling>",
      close: "</tf_tool_calling>",
      closeRegex: /<\/tf_tool_calling(_[\d.]+)?>/
    }, {
      type: "use_tool",
      open: "<use_tool>",
      close: "</use_tool>",
      closeRegex: /<\/use_tool(_[\d.]+)?>/
    }, {
      type: "browser_session",
      open: "<browser_session>",
      close: "</browser_session>",
      closeRegex: /<\/browser_session(_[\d.]+)?>/
    }, {
      type: "desktop_session",
      open: "<desktop_session>",
      close: "</desktop_session>",
      closeRegex: /<\/desktop_session(_[\d.]+)?>/
    }, {
      type: "parallel_tools",
      open: "<parallel_tools>",
      close: "</parallel_tools>",
      closeRegex: /<\/parallel_tools(_[\d.]+)?>/,
      isWrapper: true
    },
    // Interleaved Reasoning Tool Tags
    {
      type: "knowledge_hub",
      open: "<knowledge_hub>",
      close: "</knowledge_hub>",
      closeRegex: /<\/knowledge_hub(_[\d.]+)?>/
    }, {
      type: "deep_knowledge_hub",
      open: "<deep_knowledge_hub>",
      close: "</deep_knowledge_hub>",
      closeRegex: /<\/deep_knowledge_hub(_[\d.]+)?>/
    }, {
      type: "web_search",
      open: "<web_search>",
      close: "</web_search>",
      closeRegex: /<\/web_search(_[\d.]+)?>/
    }, {
      type: "deep_web_search",
      open: "<deep_web_search>",
      close: "</deep_web_search>",
      closeRegex: /<\/deep_web_search(_[\d.]+)?>/
    }, {
      type: "code_execution",
      open: "<code_execution>",
      close: "</code_execution>",
      closeRegex: /<\/code_execution(_[\d.]+)?>/
    }, {
      type: "file_operations",
      open: "<file_operations>",
      close: "</file_operations>",
      closeRegex: /<\/file_operations(_[\d.]+)?>/
    }, {
      type: "file_inventory",
      open: "<file_inventory>",
      close: "</file_inventory>",
      closeRegex: /<\/file_inventory(_[\d.]+)?>/
    }, {
      type: "plan_update",
      open: "<plan_update>",
      close: "</plan_update>",
      closeRegex: /<\/plan_update(_[\d.]+)?>/
    }, {
      type: "plan_revision",
      open: "<plan_revision>",
      close: "</plan_revision>",
      closeRegex: /<\/plan_revision(_[\d.]+)?>/
    }, {
      type: "agent_delegation",
      open: "<agent_delegation>",
      close: "</agent_delegation>",
      closeRegex: /<\/agent_delegation(_[\d.]+)?>/
    }, {
      type: "image_generation",
      open: "<image_generation>",
      close: "</image_generation>",
      closeRegex: /<\/image_generation(_[\d.]+)?>/
    }, {
      type: "video_generation",
      open: "<video_generation>",
      close: "</video_generation>",
      closeRegex: /<\/video_generation(_[\d.]+)?>/
    }, {
      type: "audio_generation",
      open: "<audio_generation>",
      close: "</audio_generation>",
      closeRegex: /<\/audio_generation(_[\d.]+)?>/
    }, {
      type: "model_3d_generation",
      open: "<model_3d_generation>",
      close: "</model_3d_generation>",
      closeRegex: /<\/model_3d_generation(_[\d.]+)?>/
    }, {
      type: "canvas_generation",
      open: "<canvas_generation>",
      close: "</canvas_generation>",
      closeRegex: /<\/canvas_generation(_[\d.]+)?>/
    }, {
      type: "image_analysis",
      open: "<image_analysis>",
      close: "</image_analysis>",
      closeRegex: /<\/image_analysis(_[\d.]+)?>/
    }, {
      type: "video_analysis",
      open: "<video_analysis>",
      close: "</video_analysis>",
      closeRegex: /<\/video_analysis(_[\d.]+)?>/
    }, {
      type: "audio_analysis",
      open: "<audio_analysis>",
      close: "</audio_analysis>",
      closeRegex: /<\/audio_analysis(_[\d.]+)?>/
    }, {
      type: "user_interaction",
      open: "<user_interaction>",
      close: "</user_interaction>",
      closeRegex: /<\/user_interaction(_[\d.]+)?>/
    }, {
      type: "skill_activation",
      open: "<skill_activation>",
      close: "</skill_activation>",
      closeRegex: /<\/skill_activation(_[\d.]+)?>/
    }, {
      type: "memory_extraction",
      open: "<memory_extraction>",
      close: "</memory_extraction>",
      closeRegex: /<\/memory_extraction(_[\d.]+)?>/
    }, {
      type: "memory_recall",
      open: "<memory_recall>",
      close: "</memory_recall>",
      closeRegex: /<\/memory_recall(_[\d.]+)?>/
    }, {
      type: "chat_history_search",
      open: "<chat_history_search>",
      close: "</chat_history_search>",
      closeRegex: /<\/chat_history_search(_[\d.]+)?>/
    }, {
      type: "compaction",
      open: "<compaction>",
      close: "</compaction>",
      closeRegex: /<\/compaction(_[\d.]+)?>/
    }];
    while (currentIndex < content.length) {
      let nearestTag = null;
      let nearestIndex = content.length;
      let openTagLength = 0;
      let citationCountFromTag = null;
      let mcpToolName = null; // Store MCP tool name for dynamic closing tag
      let planCompletionRate = null; // Store plan completion rate like "3/5"

      // Find the nearest opening tag
      tagPatterns.forEach(pattern => {
        const openIndex = content.indexOf(pattern.open, currentIndex);
        if (openIndex !== -1 && openIndex < nearestIndex) {
          nearestIndex = openIndex;
          nearestTag = pattern;
          // For tags with openRegex (like citations_N or mcp_X), find the actual tag length
          if (pattern.openRegex) {
            const searchContent = content.slice(openIndex);
            const openMatch = searchContent.match(pattern.openRegex);
            if (openMatch) {
              openTagLength = openMatch[0].length;
              // Extract citation count from <citations_N> format
              if (pattern.type === "citations" && openMatch[1]) {
                citationCountFromTag = parseInt(openMatch[1], 10);
              }
              // Extract tool name from <mcp_{tool_name}> format
              if (pattern.type === "mcp" && openMatch[1]) {
                mcpToolName = openMatch[1];
              }
              // Extract completion rate from <plan_3/5> format
              if (pattern.type === "plan" && openMatch[1]) {
                planCompletionRate = openMatch[1];
              }
            }
          } else {
            openTagLength = pattern.open.length;
          }
        }
      });

      // Add content before the tag as regular content
      if (nearestIndex > currentIndex) {
        const textContent = content.slice(currentIndex, nearestIndex).trim();
        if (textContent) {
          sections.push({
            type: "content",
            text: textContent
          });
        }
        // Update currentIndex to the start of the tag
        currentIndex = nearestIndex;
      }

      // If no more tags found, add remaining content if we haven't processed it yet
      if (!nearestTag) {
        if (currentIndex < content.length) {
          const remainingContent = content.slice(currentIndex).trim();
          if (remainingContent) {
            sections.push({
              type: "content",
              text: remainingContent
            });
          }
        }
        break;
      }

      // Use the calculated openTagLength or fallback to pattern.open.length
      const actualOpenTagLength = openTagLength || nearestTag.open.length;

      // Find closing tag - use regex if available, otherwise use indexOf
      let closeIndex = -1;
      let closeTagLength = nearestTag.close.length;
      let sectionDuration = null;
      if (nearestTag.isDynamic && mcpToolName) {
        // Dynamic MCP tag: construct closing regex based on tool name
        // Closing tag format: </mcp_{tool_name}_{duration}>
        const escapedToolName = mcpToolName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const mcpCloseRegex = new RegExp(`<\\/mcp_${escapedToolName}_([\\d.]+)>`);
        const searchContent = content.slice(nearestIndex + actualOpenTagLength);
        const match = searchContent.match(mcpCloseRegex);
        if (match) {
          closeIndex = nearestIndex + actualOpenTagLength + match.index;
          closeTagLength = match[0].length;
          // Extract duration from closing tag (e.g., </mcp_search_docs_1.23>)
          sectionDuration = parseFloat(match[1]);
        }
      } else if (nearestTag.closeRegex) {
        // Use regex to find closing tag (for patterns like </think_123>)
        const searchContent = content.slice(nearestIndex + actualOpenTagLength);
        const match = searchContent.match(nearestTag.closeRegex);
        if (match) {
          closeIndex = nearestIndex + actualOpenTagLength + match.index;
          closeTagLength = match[0].length;
          // Extract duration from closing tag like </think_15> or </think_3.92>
          const durationMatch = match[0].match(/_([\d.]+)>/);
          if (durationMatch) {
            sectionDuration = parseFloat(durationMatch[1]);
          }
        }
      } else {
        closeIndex = content.indexOf(nearestTag.close, nearestIndex + actualOpenTagLength);
      }
      if (closeIndex !== -1) {
        // Complete tag found
        const tagContent = content.slice(nearestIndex + actualOpenTagLength, closeIndex).trim();
        if (tagContent) {
          // Map tag types to section types
          let sectionType = nearestTag.type;
          if (nearestTag.type === "think") sectionType = "thinking";
          if (nearestTag.type === "deep_search") sectionType = "deep_search";
          if (nearestTag.type === "browser") sectionType = "browser";
          if (nearestTag.type === "code_interpreter") sectionType = "code_interpreter";
          if (nearestTag.type === "deep_rag") sectionType = "deep_rag";
          if (nearestTag.type === "folder_access") sectionType = "folder_access";
          if (nearestTag.type === "citations") sectionType = "citations";
          // For MCP, include tool name in section type (e.g., "mcp_search_docs")
          if (nearestTag.type === "mcp" && mcpToolName) sectionType = `mcp_${mcpToolName}`;
          if (nearestTag.type === "user_feedback") sectionType = "user_feedback";
          if (nearestTag.type === "internet_search") sectionType = "internet_search";
          if (nearestTag.type === "tf_tool_calling") sectionType = "tf_tool_calling";
          if (nearestTag.type === "use_tool") sectionType = "use_tool";
          if (nearestTag.type === "browser_session") sectionType = "browser_session";
          if (nearestTag.type === "desktop_session") sectionType = "desktop_session";
          if (nearestTag.type === "compaction") sectionType = "compaction";
          if (nearestTag.type === "parallel_tools") sectionType = "parallel_tools";
          const sectionData = {
            type: sectionType,
            text: tagContent,
            isComplete: true,
            // Tag is closed
            duration: sectionDuration // Duration in seconds (for thinking sections)
          };

          // Add citation count if available
          if (sectionType === "citations" && citationCountFromTag !== null) {
            sectionData.citationCount = citationCountFromTag;
          }

          // Add MCP tool name if available
          if (nearestTag.type === "mcp" && mcpToolName) {
            sectionData.mcpToolName = mcpToolName;
          }

          // Add plan completion rate if available
          if (nearestTag.type === "plan" && planCompletionRate) {
            sectionData.planCompletionRate = planCompletionRate;
          }

          // Add resolved agent label for completed delegations
          // (backend streams "✔️ `delegate_to_agent` (agent=Label) - N chars")
          if (sectionType === "agent_delegation") {
            sectionData.agentDelegationLabel = extractDelegationAgentLabel(tagContent);
          }

          // Recursively parse children for wrapper tags (parallel_tools)
          if (nearestTag.isWrapper) {
            sectionData.children = parseSectionsFromContent(tagContent);
            sectionData.toolCount = sectionData.children.filter(s => s.type !== "content").length;
          }
          sections.push(sectionData);
        }
        currentIndex = closeIndex + closeTagLength;
      } else {
        // Unclosed tag (streaming)
        const tagContent = content.slice(nearestIndex + actualOpenTagLength).trim();

        // Map tag types to section types
        let sectionType = nearestTag.type;
        if (nearestTag.type === "think") sectionType = "thinking";
        if (nearestTag.type === "deep_search") sectionType = "deep_search";
        if (nearestTag.type === "browser") sectionType = "browser";
        if (nearestTag.type === "code_interpreter") sectionType = "code_interpreter";
        if (nearestTag.type === "deep_rag") sectionType = "deep_rag";
        if (nearestTag.type === "folder_access") sectionType = "folder_access";
        if (nearestTag.type === "citations") sectionType = "citations";
        // For MCP, include tool name in section type (e.g., "mcp_search_docs")
        if (nearestTag.type === "mcp" && mcpToolName) sectionType = `mcp_${mcpToolName}`;
        if (nearestTag.type === "user_feedback") sectionType = "user_feedback";
        if (nearestTag.type === "internet_search") sectionType = "internet_search";
        if (nearestTag.type === "tf_tool_calling") sectionType = "tf_tool_calling";
        if (nearestTag.type === "use_tool") sectionType = "use_tool";
        if (nearestTag.type === "browser_session") sectionType = "browser_session";
        if (nearestTag.type === "desktop_session") sectionType = "desktop_session";
        if (nearestTag.type === "compaction") sectionType = "compaction";
        const sectionData = {
          type: sectionType,
          text: tagContent,
          isComplete: false // Tag is still open (streaming)
        };

        // Add citation count if available
        if (sectionType === "citations" && citationCountFromTag !== null) {
          sectionData.citationCount = citationCountFromTag;
        }

        // Add MCP tool name if available
        if (nearestTag.type === "mcp" && mcpToolName) {
          sectionData.mcpToolName = mcpToolName;
        }

        // Add plan completion rate if available
        if (nearestTag.type === "plan" && planCompletionRate) {
          sectionData.planCompletionRate = planCompletionRate;
        }

        // Add resolved agent label for streaming delegations
        if (sectionType === "agent_delegation") {
          sectionData.agentDelegationLabel = extractDelegationAgentLabel(tagContent);
        }

        // Recursively parse children for wrapper tags (parallel_tools)
        if (nearestTag.isWrapper) {
          sectionData.children = parseSectionsFromContent(tagContent);
          sectionData.toolCount = sectionData.children.filter(s => s.type !== "content").length;
        }
        sections.push(sectionData);
        currentIndex = content.length; // Mark as fully processed
        break;
      }
    }

    // Separate sections by type
    const thinkingSections = sections.filter(s => s.type === "thinking");
    const deepSearchSections = sections.filter(s => s.type === "deep_search");
    sections.filter(s => s.type === "browser");
    sections.filter(s => s.type === "folder_access");
    const contentSections = sections.filter(s => s.type === "content");

    // Store deep search content for the header display
    if (deepSearchSections.length > 0) {
      setDeepSearchContent(deepSearchSections.map(s => s.text).join("\n\n"));
    }
    return {
      restOfContent: thinkingSections.map(s => s.text).join("\n\n"),
      answer: contentSections.map(s => s.text).join("\n\n"),
      sections: sections // Preserve order for contextual rendering
    };
  };
  useEffect(() => {
    if (processedMarkdown) {
      const {
        restOfContent,
        answer,
        sections
      } = processStreamedContent(processedMarkdown);

      // Strip streaming symbols from section texts when showInProgressWithStyle is enabled
      let processedSections = sections;
      let processedAnswer = answer;
      let processedRestOfContent = restOfContent;
      if (showInProgressWithStyle) {
        processedSections = sections.map((section, index) => {
          // Only strip from the last section
          if (index === sections.length - 1) {
            return {
              ...section,
              text: section.text.replace(/[\u26AB\u26AA]$/g, "").trim()
            };
          }
          return section;
        });
        processedAnswer = answer.replace(/[\u26AB\u26AA]$/g, "").trim();
        processedRestOfContent = restOfContent.replace(/[\u26AB\u26AA]$/g, "").trim();
      }
      setRestOfContent(processedRestOfContent);
      setFinalAnswer(processedAnswer);
      setContentSections(matchFnDetailsToSections(processedSections, resolvedFnDetails));

      // Remove deep_search tags from the markdown for rendering
      let markdownWithoutDeepSearch = processedMarkdown.replace(/<deep_search>[\s\S]*?<\/deep_search>/g, "").replace(/<folder_access>[\s\S]*?<\/folder_access>/g, "").replace(/<parallel_tools>[\s\S]*?<\/parallel_tools(_[\d.]+)?>/g, "").replace(/<compaction>[\s\S]*?<\/compaction(_[\d.]+)?>/g, "").trim();

      // Remove think tags when hideReasoning is false (i.e., "Show reasoning" is OFF)
      if (!hideReasoning) {
        markdownWithoutDeepSearch = markdownWithoutDeepSearch.replace(/<think>[\s\S]*?<\/think(_[\d.]+)?>/g, "").trim();
      }

      // Strip streaming symbols when showInProgressWithStyle is enabled
      if (showInProgressWithStyle) {
        markdownWithoutDeepSearch = markdownWithoutDeepSearch.replace(/[\u26AB\u26AA]$/g, "").trim();
      }
      setCleanedMarkdown(markdownWithoutDeepSearch);
    }
  }, [processedMarkdown, hideReasoning, isMessageStreaming, showInProgressWithStyle, resolvedFnDetails]);
  const validateMermaid = async () => {
    try {
      if (processedMarkdown?.includes("mermaid")) {
        const extractedCode = extractMermaidCode(processedMarkdown);
        if (processedMarkdown?.includes("zenuml")) {
          setIsValid(true);
        } else {
          await mermaid.parse(extractedCode);
        }
        setIsValid(true);
      }
    } catch (err) {
      setIsValid(false);
    }
  };
  useEffect(() => {
    const processMarkdown = async markdownText => {
      const imageRegex = /!\[([^\]]*)\]\(([^\)]+)\)/g;
      let matches = Array.from(markdownText.matchAll(imageRegex));
      for (let match of matches) {
        match[0];
        let url = match[2];
        if (!processedImages.has(url) && !url.startsWith("http")) {
          // if url does not start with pdf-image then it is a local image
          let _filename = null;
          if (!url.startsWith("pdf-image")) {
            _filename = `imported-image/${workspaceid}/${url}`;
          } else {
            _filename = `imported-image/${url}`;
          }
          const newUrl = await S3downloadUrlRequest({
            filename: _filename,
            context: "pdf",
            workspaceid
          });
          setProcessedImages(prevState => new Map(prevState.set(url, newUrl)));
        } else if (processedImages.has(url) && !url.startsWith("http")) {
          // Validate existing URL before using
          let _filename = null;
          if (!url.startsWith("pdf-image")) {
            _filename = `imported-image/${workspaceid}/${url}`;
          } else {
            _filename = `imported-image/${url}`;
          }
          const existingUrl = processedImages.get(url)?.url;
          const newUrl = await S3downloadUrlRequest({
            filename: _filename,
            context: "pdf",
            workspaceid,
            existingUrl
          });
          if (newUrl?.url !== existingUrl) {
            setProcessedImages(prevState => new Map(prevState.set(url, newUrl)));
          }
        }
      }
      return markdownText;
    };
    processMarkdown(markdownText);
  }, [markdownText, processedImages]);
  useEffect(() => {
    let processedMarkdownText = markdownText;
    const imageRegex = /!\[([^\]]*)\]\(([^\)]+)\)/g;
    let matches = Array.from(processedMarkdownText.matchAll(imageRegex));
    matches.forEach(match => {
      const fullMatch = match[0];
      let url = match[2];
      if (processedImages.has(url) && !url.startsWith("http")) {
        const newUrl = processedImages.get(url);
        processedMarkdownText = processedMarkdownText.replace(fullMatch, fullMatch.replace(url, newUrl?.url));
      }
    });
    if (coder == false && !processedMarkdownText?.includes("```mermaid")) {
      const regex = /(```(?:markdown)?\s*\n?([\s\S]*?)\n?```)/g;
      processedMarkdownText = processedMarkdownText.replace(regex, "$2");
    }
    if (!showCodeInExecution) processedMarkdownText = replaceCodeBlocksWithPlaceholder(processedMarkdownText);
    setProcessedMarkdown(processedMarkdownText);
    validateMermaid();
  }, [markdownText, processedImages]);
  function replaceCodeBlocksWithPlaceholder(markdown) {
    // Handle streaming text by suppressing from the start of a code block
    // even if it's not complete yet

    // First, check if we're in the middle of an unclosed code block
    const codeBlockStarts = (markdown.match(/```/g) || []).length;
    const isInCodeBlock = codeBlockStarts % 2 === 1; // Odd number means unclosed

    if (isInCodeBlock) {
      // Find the last occurrence of ``` that starts a code block
      const lastCodeBlockStart = markdown.lastIndexOf("```");
      if (lastCodeBlockStart !== -1) {
        // Suppress everything from the start of the code block
        const beforeCodeBlock = markdown.substring(0, lastCodeBlockStart);
        // Check if it's a mermaid block
        const afterTripleBacktick = markdown.substring(lastCodeBlockStart + 3);
        const isMermaid = afterTripleBacktick.trimStart().startsWith("mermaid");
        if (!isMermaid) {
          // Extract language if present
          const langMatch = afterTripleBacktick.match(/^(\w+)/);
          const lang = langMatch ? langMatch[1] : "";
          return beforeCodeBlock + "```" + (lang ? lang + "\n" : "\n") + "Suppressed code block (streaming...)\n";
        }
      }
    }

    // Handle complete code blocks
    const codeBlockRegex = /```(?!mermaid\b)(\w*\n[\s\S]*?)```/g;

    // Replace complete code blocks with placeholder
    const placeholderMarkdown = markdown.replace(codeBlockRegex, (match, p1) => {
      const lang = p1.split("\n")[0].trim();
      return "```" + (lang ? lang + "\n" : "\n") + "Suppressed code block\n```";
    });
    return placeholderMarkdown;
  }
  useEffect(() => {
    const loadMermaid = async () => {
      mermaid.initialize({
        startOnLoad: true,
        darkMode: mode == "dark",
        theme: "base",
        themeVariables: {
          background: currentTheme?.theme?.backgroundColor,
          primaryColor: customChartingConfig?.primaryColor || currentTheme?.theme?.primary,
          primaryTextColor: customChartingConfig?.primaryTextColor || currentTheme?.theme?.white,
          primaryBorderColor: customChartingConfig?.primaryBorderColor || currentTheme?.theme?.primary,
          lineColor: customChartingConfig?.lineColor || currentTheme?.theme?.darkGrey,
          secondaryColor: customChartingConfig?.secondaryColor || currentTheme?.theme?.mediumGrey,
          tertiaryColor: customChartingConfig?.tertiaryColor || currentTheme?.theme?.lightGrey,
          fontFamily: "normalFont",
          fontSize: currentTheme?.theme?.small_font_size,
          primaryTextColor: currentTheme?.theme?.font_color,
          quadrant1Fill: currentTheme?.theme?.lightGrey,
          quadrant2Fill: currentTheme?.theme?.lightGrey,
          quadrant3Fill: currentTheme?.theme?.lightGrey,
          quadrant4Fill: currentTheme?.theme?.lightGrey,
          quadrant1TextFill: currentTheme?.theme?.primary,
          quadrant2TextFill: currentTheme?.theme?.primary,
          quadrant3TextFill: currentTheme?.theme?.primary,
          quadrant4TextFill: currentTheme?.theme?.primary,
          quadrantPointFill: currentTheme?.theme?.primary,
          quadrantPointTextFill: currentTheme?.theme?.primary,
          quadrantXAxisTextFill: currentTheme?.theme?.font_color,
          quadrantYAxisTextFill: currentTheme?.theme?.font_color,
          quadrantInternalBorderStrokeFill: currentTheme?.theme?.darkGrey,
          quadrantExternalBorderStrokeFill: currentTheme?.theme?.darkGrey,
          quadrantAxisLineStrokeFill: currentTheme?.theme?.font_color,
          quadrantPointStrokeFill: currentTheme?.theme?.font_color,
          quadrantTitleFill: currentTheme?.theme?.font_color,
          xyChart: {
            backgroundColor: customChartingConfig?.xyBackgroundColor || currentTheme?.theme?.transparent,
            titleColor: customChartingConfig?.titleColor || currentTheme?.theme?.font_color,
            xAxisLabelColor: customChartingConfig?.xAxisLabelColor || currentTheme?.theme?.font_color,
            yAxisLabelColor: customChartingConfig?.yAxisLabelColor || currentTheme?.theme?.font_color,
            yAxisTitleColor: customChartingConfig?.yAxisTitleColor || currentTheme?.theme?.font_color,
            xAxisTitleColor: customChartingConfig?.xAxisTitleColor || currentTheme?.theme?.font_color,
            yAxisLineColor: customChartingConfig?.yAxisLineColor || currentTheme?.theme?.font_color,
            xAxisLineColor: customChartingConfig?.xAxisLineColor || currentTheme?.theme?.font_color,
            yAxisTickColor: customChartingConfig?.yAxisTickColor || currentTheme?.theme?.font_color,
            xAxisTickColor: customChartingConfig?.xAxisTickColor || currentTheme?.theme?.font_color,
            plotColorPalette: `${customChartingConfig?.plotPrimaryColor || "#1db8c6"},${customChartingConfig?.plotSecondaryColor || "#E95E0B"},${customChartingConfig?.plotTertiaryColor || "#28c552"}, #f10b0b`
          }
        },
        flowchart: {
          useMaxWidth: false,
          //if the flowchart should not use the whole available width then set this to false
          textMargin: 20 //increased margin around the text
        }
      });
      await mermaid.registerExternalDiagrams([zenuml]);
      mermaid.contentLoaded();
    };
    if (processedMarkdown?.includes("```mermaid")) {
      setSuppressCodeHighlighting(true);
      if (isValid && !isMessageStreaming) {
        loadMermaid();
      }
    } else {
      setSuppressCodeHighlighting(false);
    }
  }, [currentTheme?.mode, processedMarkdown, isValid, isMessageStreaming, JSON.stringify(customChartingConfig)]);
  //  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
  // <path fill="rgb(29, 184, 198)" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  // </svg>

  const md = new MarkdownIt({
    breaks: true,
    html: renderHTMLinMarkdown,
    linkify: renderHTMLinMarkdown,
    highlight: function (str, lang) {
      const _id = Math.random().toString(36).substring(2, 8);
      const part1highlight = `<script>
      async function copyToClipboard(elementId) {
        const codeElement = document.getElementById(elementId + '_code');
        const textToCopy = codeElement?.textContent || '';
        
        // Try to use the centralized clipboard utility if available
        if (window.copyToClipboard && typeof window.copyToClipboard === 'function') {
          try {
            const success = await window.copyToClipboard(textToCopy);
            if (success) {
              console.log('Copied to clipboard via window.copyToClipboard');
              return;
            }
          } catch (err) {
            console.error('window.copyToClipboard failed:', err);
          }
        }
        
        try {
          // Try Electron API directly
          if (window.electronAPI?.clipboardWriteText) {
            const result = await window.electronAPI.clipboardWriteText(textToCopy);
            if (result?.success) {
              console.log('Copied to clipboard via Electron API');
              return;
            }
          }
          
          // Fall back to navigator.clipboard for modern web browsers
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(textToCopy);
            console.log('Copied to clipboard via navigator.clipboard');
            return;
          }
          
          // Final fallback: use DOM method for older browsers
          fallbackCopy(textToCopy);
        } catch (err) {
          console.error('Failed to copy:', err);
          fallbackCopy(textToCopy);
        }
      }
      
      function fallbackCopy(text) {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        textarea.style.top = '0';
        textarea.setAttribute('readonly', '');
        document.body.appendChild(textarea);
        
        textarea.focus();
        textarea.select();
        try {
          const successful = document.execCommand('copy');
          alert("DEBUG INLINE FALLBACK: execCommand result: " + successful);
          if (successful) {
            console.log('Copied to clipboard via fallback method');
          }
        } catch (err) {
          console.error('Fallback copy failed:', err);
          alert("DEBUG INLINE FALLBACK: Error: " + err.message);
        }
        document.body.removeChild(textarea);
      }
      function viewHTML(id) {
        const content = document.getElementById(id + "_code").textContent;
        const newTab = window.open();
        newTab.document.write(content);
        newTab.document.close();
      }
      function view3D(id) {
        window.view3D(id);
      }
      function smartPreview(id) {
        window.smartPreview(id);
      }
    </script>
   <pre style="overflow-x: auto; max-width: 100%;"><div class="code-top-bar ${mode}">
      <span style="font-size: 12px; color: inherit">${!showCodeInExecution ? "" : lang}</span>
      <div class="code-top-bar-buttons">
        <span onclick="copyToClipboard('${_id}')" id=${_id} class="markdown-it-code-copy code-button" ${!showCodeInExecution ? "style='display: none;'" : ""} title="Copy">Copy</span>
        ${lang.toLowerCase() === "html" ? `<span onclick="window.smartPreview('${_id}')" class="markdown-it-code-view code-button" ${!showCodeInExecution ? "style='display: none;'" : ""} title="Preview">Preview</span>` : lang.toLowerCase() === "threejs" || lang.toLowerCase() === "3d" || lang.toLowerCase() === "obj" || lang.toLowerCase() === "webgl" ? `<span onclick="window.view3D('${_id}')" class="markdown-it-code-view code-button" ${!showCodeInExecution ? "style='display: none;'" : ""} title="View 3D Model">Preview 3D</span>` : ""}
      </div>
    </div><code id=${_id + "_code"} class="hljs ${mode}" style="display: block; overflow-x: auto; white-space: pre;">`;
      const canRenderMermaid = !isMessageStreaming || isPostTaskStatus(processingStatus);
      if (lang && lang.toLowerCase() === "mermaid" && isValid && canRenderMermaid && renderHTMLinMarkdown) {
        return `<pre style="overflow: auto;"><div class="mermaid ${mode}">` + str + "</div></pre>";
      } else if (lang && lang.toLowerCase() === "mermaid" && (!isValid || !canRenderMermaid) && renderHTMLinMarkdown) {
        return `<div class="mermaid-placeholder" style="color: ${currentTheme?.theme?.font_color}; font-size: 14px; font-family: boldFont">` + "Plotting..." + "</div>";
      } else if (lang && hljs.getLanguage(lang) && !suppressCodeHighlighting && lang !== "mermaid" && lang !== "markdown" && renderHTMLinMarkdown) {
        try {
          return part1highlight + hljs.highlight(str, {
            language: lang,
            ignoreIllegals: true
          }).value + "</code></pre>";
        } catch (__) {}
      }
      return !suppressCodeHighlighting ? part1highlight + md.utils.escapeHtml(str) + "</code></pre>" : str;
    }
  });

  // Intercept and load images before rendering markdown
  md.renderer.rules.image = function (tokens, idx, options, env, self) {
    const token = tokens[idx];
    const srcIndex = token.attrIndex("src");
    if (srcIndex >= 0) {
      const imgUrl = token.attrs[srcIndex][1];

      // Create a new image object and set its src to trigger loading
      const img = new Image();
      img.src = imgUrl;

      // Add onerror handler to refresh expired URLs
      const refreshAttrIndex = token.attrIndex("onerror");
      if (refreshAttrIndex < 0) {
        token.attrs.push(["onerror", `this.onerror=null; this.src='${imgUrl}'; this.style.opacity='0.7';`]);
      }
    }

    // Default renderer for images
    return self.renderToken(tokens, idx, options);
  };
  md.use(markdownItKatex, {});
  // if (!suppressCodeHighlighting) md.use(markdownHighlight, { inline: false });
  md.use(mila, {
    attrs: {
      target: "_blank",
      rel: "noopener"
    }
  });

  // Configure footnote plugin for citations
  md.use(footnote);

  // Custom link renderer to show domain name and favicon
  const defaultLinkRenderer = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };
  md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    const token = tokens[idx];
    const hrefIndex = token.attrIndex("href");
    if (hrefIndex >= 0) {
      const href = token.attrs[hrefIndex][1];

      // Only process external URLs (not internal links)
      if (href.startsWith("http")) {
        try {
          const url = new URL(href);
          const domain = url.hostname.replace("www.", "");

          // Find the next text token to check if it matches the URL
          const textToken = tokens[idx + 1];
          if (textToken && textToken.type === "text" && textToken.content === href) {
            // Check if we're inside a footnote definition by looking at surrounding tokens
            const isInFootnote = checkIfInFootnote(tokens, idx);

            // Create descriptive text - enhanced for footnotes, simple for inline
            let displayText = domain;
            if (isInFootnote) {
              // For footnotes, include path segments for better differentiation
              if (url.pathname && url.pathname !== "/" && url.pathname !== "") {
                const pathSegments = url.pathname.split("/").filter(segment => segment);
                if (pathSegments.length > 0) {
                  // Show the last 1-2 path segments to keep it readable
                  const relevantSegments = pathSegments.slice(-2);
                  displayText = `${domain}/${relevantSegments.join("/")}`;
                }
              }
            }
            // For inline links, just use domain (existing behavior)

            // Add favicon as a prefix to the content
            const faviconUrl = `https://www.google.com/s2/favicons?domain=${domain}&sz=16`;
            textToken.content = `<img src="${faviconUrl}" alt="" style="width: 12px; height: 12px; margin-right: 4px; vertical-align: middle; display: inline-flex" onerror="this.style.display='none'"/>${displayText}`;

            // Mark this token to use raw HTML
            textToken.type = "html_inline";
          }
        } catch (e) {
          // If URL parsing fails, keep original
        }
      }
    }
    return defaultLinkRenderer(tokens, idx, options, env, self);
  };

  // Helper function to check if we're inside a footnote definition
  function checkIfInFootnote(tokens, currentIdx) {
    // Look backwards through tokens to find if we're in a footnote block
    for (let i = currentIdx - 1; i >= 0; i--) {
      const token = tokens[i];

      // If we find a footnote_block_open, we're in a footnote
      if (token.type === "footnote_block_open") {
        return true;
      }

      // If we find a footnote_block_close, we've exited footnote context
      if (token.type === "footnote_block_close") {
        return false;
      }

      // If we find a footnote_open, we're in a footnote definition
      if (token.type === "footnote_open") {
        return true;
      }

      // If we find a footnote_close, we've exited footnote context
      if (token.type === "footnote_close") {
        return false;
      }

      // Stop looking if we hit a major block boundary
      if (token.type === "document_open" || token.type === "paragraph_open") {
        break;
      }
    }
    return false;
  }

  // Preprocess URLs in brackets to proper markdown links
  const preprocessBracketedUrls = markdown => {
    // Match URLs wrapped in square brackets like [https://example.com]
    return markdown.replace(/\[((https?:\/\/[^\]]+))\]/g, "[$2]($2)");
  };

  // Preprocess pure JSON content to wrap with code fences for syntax highlighting
  const preprocessJsonContent = markdown => {
    if (!markdown) return markdown;
    const trimmed = markdown.trim();
    // Check if content is pure JSON (starts with { or [ and ends with } or ])
    // Also check it's not already wrapped in code fences
    if ((trimmed.startsWith("{") && trimmed.endsWith("}") || trimmed.startsWith("[") && trimmed.endsWith("]")) && !trimmed.includes("```")) {
      try {
        // Validate it's actually valid JSON
        JSON.parse(trimmed);
        return "```json\n" + trimmed + "\n```";
      } catch (e) {
        // Not valid JSON, return as-is
        return markdown;
      }
    }
    return markdown;
  };

  // Tool emoji mapping - using shared module
  const {
    getToolEmoji
  } = AppToolEmojis;

  // Format tool name for display
  const formatToolName = toolId => {
    return toolId.split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  };

  // Preprocess tools wrapped in ~text~
  const preprocessTools = markdown => {
    // Match text wrapped in ~ like ~code_interpreter~
    return markdown.replace(/~([a-zA-Z0-9_]+)~/g, (match, toolId) => {
      const emoji = getToolEmoji(toolId);
      const displayName = formatToolName(toolId);

      // Return markdown formatted text - bold with emoji
      return `**${emoji} ${displayName}**`;
    });
  };

  // Apply citation preprocessing before rendering
  // First check if content is pure JSON and wrap it for syntax highlighting
  const jsonProcessedMarkdown = preprocessJsonContent(cleanedMarkdown);
  const citationProcessedMarkdown = preprocessCitations(jsonProcessedMarkdown);
  const urlProcessedMarkdown = preprocessBracketedUrls(citationProcessedMarkdown);
  const toolProcessedMarkdown = preprocessTools(urlProcessedMarkdown);
  const html = md.render(!renderHTMLinMarkdown ? toolProcessedMarkdown.replace(/\n/g, "\n\n") : toolProcessedMarkdown);
  const computeAspectRatio = svg => {
    const width = svg.width.baseVal.value;
    const height = svg.height.baseVal.value;
    return width / height;
  };
  const computeDimensions = ratio => {
    let targetWidth, targetHeight;

    // if width > height (landscape)
    if (ratio > 1) {
      targetWidth = Math.min(750, Math.max(350, ratio * 350));
      targetHeight = targetWidth / ratio;
    } else {
      targetHeight = Math.min(750, Math.max(350, 350 / ratio));
      targetWidth = targetHeight * ratio;
    }
    return {
      width: targetWidth,
      height: targetHeight
    };
  };
  const svgToDataURL = async (svg, width, height) => {
    return new Promise((resolve, reject) => {
      // Serialize SVG
      const serializedSVG = new XMLSerializer().serializeToString(svg);

      // Base64 encode and create DataURL
      const svgBase64 = btoa(unescape(encodeURIComponent(serializedSVG)));
      const svgDataURL = "data:image/svg+xml;base64," + svgBase64;

      // Create image to hold SVG DataURL
      const img = new Image();
      const SCALE_FACTOR = 2; // Adjust as needed for higher or lower quality

      img.onload = function () {
        // Create canvas and set its size with the scaling factor
        const canvas = document.createElement("canvas");
        canvas.width = width * SCALE_FACTOR;
        canvas.height = height * SCALE_FACTOR;
        const ctx = canvas.getContext("2d");
        // ctx.scale(SCALE_FACTOR, SCALE_FACTOR);
        ctx.drawImage(img, 0, 0, width * SCALE_FACTOR, height * SCALE_FACTOR);

        // Get PNG DataURL from canvas
        const pngDataURL = canvas.toDataURL("image/png", 1.0); // 1.0 = full quality
        resolve(pngDataURL);
      };
      img.onerror = function () {
        reject("Failed to load image");
      };
      img.src = svgDataURL;
    });
  };
  const removeBackgrounds = node => {
    const backgrounds = [];
    let counter = 0; // Introduce a counter
    while (node && counter < 10) {
      // Check counter
      backgrounds.push(node.style.backgroundColor);
      node.style.backgroundColor = "transparent";
      node = node.parentNode;
      counter++; // Increment the counter
    }
    return backgrounds;
  };
  const restoreBackgrounds = (node, backgrounds) => {
    let i = 0;
    let counter = 0; // Introduce a counter
    while (node && i < backgrounds.length && counter < 10) {
      // Check counter
      node.style.backgroundColor = backgrounds[i++];
      node = node.parentNode;
      counter++; // Increment the counter
    }
  };
  const handleCopy = async () => {
    if (containerRef.current) {
      const tempNodes = [];
      try {
        onCopy();

        // Get plain text content for clipboard
        const textContent = containerRef.current.innerText || containerRef.current.textContent || "";

        // Try modern Clipboard API first (most reliable)
        if (navigator.clipboard && navigator.clipboard.writeText) {
          try {
            await navigator.clipboard.writeText(textContent);
            console.log("Copied using Clipboard API!");
            return;
          } catch (clipboardErr) {
            console.log("Clipboard API failed, trying fallback methods:", clipboardErr);
          }
        }

        // Fallback: Try postMessage to parent (for iframe scenarios)
        try {
          window?.parent?.postMessage({
            type: "tf_clipboard_iframe",
            message: textContent
          }, "*");
          console.log("Sent to parent via postMessage");
        } catch (postErr) {
          console.log("postMessage failed:", postErr);
        }

        // Fallback: execCommand with selection (legacy browsers)
        const selection = window.getSelection();
        const svgs = containerRef.current.querySelectorAll("svg");
        for (let svg of svgs) {
          const ratio = computeAspectRatio(svg);
          const {
            width: targetWidth,
            height: targetHeight
          } = computeDimensions(ratio);
          const dataURL = await svgToDataURL(svg, targetWidth, targetHeight);
          const img = document.createElement("img");
          img.width = targetWidth;
          img.height = targetHeight;
          img.src = dataURL;

          // Remember the position of SVG and temporarily remove it
          const {
            parentNode,
            nextSibling
          } = svg;
          parentNode.removeChild(svg);

          // Insert the image in the place where SVG was
          parentNode.insertBefore(img, nextSibling);
          tempNodes.push({
            img,
            svg,
            parentNode,
            nextSibling
          });
        }
        if (selection.rangeCount > 0) {
          selection.removeAllRanges();
        }
        const backgrounds = removeBackgrounds(containerRef.current);
        containerRef.current.overflow = "none";
        const range = document.createRange();
        range.selectNode(containerRef.current);
        selection.addRange(range);
        try {
          // Attempt to copy using execCommand
          const successful = document.execCommand("copy");
          if (successful) {
            console.log("Copied using execCommand!");
          } else {
            // Final fallback: create a temporary textarea
            const textarea = document.createElement("textarea");
            textarea.value = textContent;
            textarea.style.position = "fixed";
            textarea.style.left = "-9999px";
            textarea.style.top = "-9999px";
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            console.log("Copied using textarea fallback!");
          }
        } catch (err) {
          console.error("Unable to copy with execCommand:", err);
        }
        restoreBackgrounds(containerRef.current, backgrounds);

        // Clear selection after copying
        selection.removeAllRanges();
      } catch (err) {
        console.log("Failed to copy: ", err);
        // Ultimate fallback: try textarea method even on error
        try {
          const textContent = containerRef.current.innerText || containerRef.current.textContent || "";
          const textarea = document.createElement("textarea");
          textarea.value = textContent;
          textarea.style.position = "fixed";
          textarea.style.left = "-9999px";
          textarea.style.top = "-9999px";
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          console.log("Copied using emergency textarea fallback!");
        } catch (fallbackErr) {
          console.error("All copy methods failed:", fallbackErr);
        }
      } finally {
        for (let {
          img,
          svg,
          parentNode,
          nextSibling
        } of tempNodes) {
          parentNode.removeChild(img);
          parentNode.insertBefore(svg, nextSibling);
        }
      }
    }
  };
  // from html object extract all the href and put them in an array called links
  const links = [];
  const htmlObject = document.createElement("div");
  htmlObject.innerHTML = html;
  const hrefs = htmlObject.querySelectorAll("a");
  hrefs.forEach(href => {
    // add the link only if app.toothfairyai.com or app.toothfairylab.link is not present in the link. Add a check where if the title link is tframe then do not add it to the links array
    if (!href.href.includes("app.toothfairyai.com") && !href.href.includes("app.toothfairylab.link") && href.title !== "tframe") {
      links.push(href.href);
    }
  });
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      flexDirection: "column",
      display: "flex"
    },
    onMouseEnter: e => {
      setIsActionVisible(true);
    },
    onMouseLeave: e => {
      setIsActionVisible(false);
    }
  }, isActionVisible && showCopyButton && /*#__PURE__*/React__default.createElement(View, {
    style: {
      position: "absolute",
      right: 0,
      display: "flex",
      flexDirection: "row",
      gap: 10,
      alignItems: "center"
    }
  }, !suppressCopyButton && /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.quickCopy,
    color: copyIconColor,
    size: 16,
    onPress: handleCopy,
    isClickable: true
  }), showTextToSpeech && !suppressTextToSpeech && /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.speakers,
    color: isSpeechGettingProcessed ? currentTheme?.theme?.darkGrey : copyIconColor,
    size: 16,
    onPress: () => {
      updateTextForSpeech(stripForSpeech(processedMarkdown));
    },
    isClickable: !isSpeechGettingProcessed
  }), showFeedbackButtons && /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row",
      alignItems: "center",
      gap: 10
    }
  }, /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.thumbsDown,
    color: copyIconColor,
    size: 16,
    onPress: onNegativeFeedbackPress,
    isClickable: true
  }), /*#__PURE__*/React__default.createElement(AppIcon, {
    icon: AppAssets.icons.thumbsUp,
    color: copyIconColor,
    size: 16,
    onPress: onPositiveFeedbackPress,
    isClickable: true
  }))), contentSections.length > 0 && (hasLongReasoning || hasDeepSearch || hasBrowser || hasCodeInterpreter || hasDeepRag || hasFolderAccess || hasCitations || hasMcp || hasPlan || hasUserFeedback || hasInternetSearch || hasDeepInternetSearch || hasTfToolCalling || hasUseTool || hasBrowserSession || hasParallelTools || hasKnowledgeHub || hasDeepKnowledgeHub || hasWebSearch || hasDeepWebSearch || hasCodeExecution || hasFileOperations || hasFileInventory || hasPlanUpdate || hasPlanRevision || hasAgentDelegation || hasImageGeneration || hasVideoGeneration || hasAudioGeneration || hasModel3dGeneration || hasCanvasGeneration || hasImageAnalysis || hasVideoAnalysis || hasAudioAnalysis || hasUserInteraction || hasSkillActivation || hasMemoryExtraction || hasMemoryRecall || hasChatHistorySearch || hasCompaction) ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingTop: 20
    },
    className: "reasoning-container"
  }, contentSections.map((section, index) => {
    const tagConfig = getTagConfig(section.type);
    // Default to collapsed for all sections
    const isExpanded = expandedSections[index] === undefined ? false : expandedSections[index];
    if (section.type === "content") {
      const isLastSection = index === contentSections.length - 1;
      return /*#__PURE__*/React__default.createElement("div", {
        key: index,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          maxWidth: "100%"
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "markdown-body",
        style: {
          ...markdownStyle,
          marginTop: index > 0,
          paddingTop: 0
        },
        dangerouslySetInnerHTML: {
          __html: md.render(preprocessCitations(section.text))
        }
      }), showInProgressWithStyle && isMessageStreaming && isLastSection && /*#__PURE__*/React__default.createElement("div", {
        style: {
          marginTop: 8,
          height: 40
        }
      }, /*#__PURE__*/React__default.createElement(TypingText, {
        style: {
          fontSize: currentTheme?.theme?.small_font_size
        },
        textToDisplay: "",
        showOnlyIndicator: !processingStatus,
        useRotatingWords: !!processingStatus,
        processing_status: processingStatus,
        agentColor: agentColor,
        kaleidoscopeSize: 10,
        isStreaming: isMessageStreaming
      })));
    }
    if (!tagConfig) return null;

    // Check if this is a thinking section that should hide expand functionality
    // When hideReasoning is false (i.e., "Show reasoning" is OFF), hide the expand functionality
    const isThinkingWithHiddenReasoning = section.type === "thinking" && !hideReasoning;

    // Show streaming indicator when text shows "...ing" state
    // This matches the getText() condition: isMessageStreaming || !tagConfig.isStopped
    const isStreaming = isMessageStreaming || !tagConfig.isStopped;

    // Widget mode: tool calls use the agent accent color (light/dark) and are
    // not expandable for public users unless showToolCallsDetailsInWidget is on.
    const toolColor = isInWidget ? agentColor || tagConfig.color : tagConfig.color;
    const canExpand = !isThinkingWithHiddenReasoning && (!isInWidget || showToolCallsDetailsInWidget);

    // Tool-call sections use the sidemenu "functions" icon at 12px.
    const isToolSection = TOOL_SECTION_TYPES.has(section.type) || section.type?.startsWith("mcp_");
    const sectionIcon = isToolSection ? AppAssets?.icons?.functions : tagConfig.icon;
    const sectionIconSize = isToolSection ? 12 : 13;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        marginTop: index > 0 ? 8 : 4,
        marginBottom: 4,
        padding: 0
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        padding: "2px 0",
        cursor: canExpand ? "pointer" : "default",
        fontFamily: "normalFont"
      },
      onClick: canExpand ? () => toggleSectionExpand(index) : undefined
    }, /*#__PURE__*/React__default.createElement(AppIcon, {
      icon: sectionIcon,
      color: toolColor,
      size: sectionIconSize,
      style: {
        marginRight: "6px"
      }
    }), /*#__PURE__*/React__default.createElement("span", {
      style: {
        fontSize: "13px",
        color: toolColor,
        fontWeight: 600,
        marginRight: "6px",
        fontFamily: "normalFont"
      }
    }, getSectionDisplayText(section, tagConfig, section.mcpToolName || section.agentDelegationLabel || section.citationCount || section.planCompletionRate || section.toolCount)), isStreaming && /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "inline-block",
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        background: toolColor,
        marginRight: "6px",
        animation: "pulse 1.5s ease-in-out infinite"
      }
    }), canExpand && /*#__PURE__*/React__default.createElement(AppIcon, {
      icon: isExpanded ? AppAssets?.icons?.collapseReasoning : AppAssets?.icons?.expandReasoning,
      color: toolColor,
      size: 12,
      style: {
        marginLeft: "auto"
      }
    })), isExpanded && canExpand && (section.type === "parallel_tools" && section.children ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        padding: "4px 0",
        fontFamily: "normalFont"
      }
    }, section.children.map((child, childIdx) => {
      if (child.type === "content") {
        return /*#__PURE__*/React__default.createElement("div", {
          key: childIdx,
          className: "markdown-body",
          style: {
            ...markdownStyle,
            padding: "6px 12px",
            fontFamily: "normalFont",
            marginTop: 0,
            paddingTop: 0
          },
          dangerouslySetInnerHTML: {
            __html: md.render(preprocessCitations(child.text))
          }
        });
      }
      const childTagConfig = getTagConfig(child.type);
      if (!childTagConfig) return null;
      const childIsExpanded = expandedSections[`${index}-${childIdx}`] === undefined ? false : expandedSections[`${index}-${childIdx}`];
      const childIsStreaming = isMessageStreaming || !childTagConfig.isStopped;
      const childToolColor = isInWidget ? agentColor || childTagConfig.color : childTagConfig.color;
      return /*#__PURE__*/React__default.createElement("div", {
        key: childIdx,
        style: {
          margin: "2px 0",
          padding: 0
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          padding: "2px 0",
          cursor: canExpand ? "pointer" : "default",
          fontFamily: "normalFont"
        },
        onClick: canExpand ? () => toggleSectionExpand(`${index}-${childIdx}`) : undefined
      }, /*#__PURE__*/React__default.createElement(AppIcon, {
        icon: AppAssets?.icons?.functions,
        color: childToolColor,
        size: 12,
        style: {
          marginRight: "6px"
        }
      }), /*#__PURE__*/React__default.createElement("span", {
        style: {
          fontSize: "12px",
          color: childToolColor,
          fontWeight: 600,
          marginRight: "6px",
          fontFamily: "normalFont"
        }
      }, getSectionDisplayText(child, childTagConfig, child.mcpToolName || child.agentDelegationLabel || child.citationCount || child.planCompletionRate)), childIsStreaming && /*#__PURE__*/React__default.createElement("span", {
        style: {
          display: "inline-block",
          width: "5px",
          height: "5px",
          borderRadius: "50%",
          background: childToolColor,
          marginRight: "6px",
          animation: "pulse 1.5s ease-in-out infinite"
        }
      }), canExpand && /*#__PURE__*/React__default.createElement(AppIcon, {
        icon: childIsExpanded ? AppAssets?.icons?.collapseReasoning : AppAssets?.icons?.expandReasoning,
        color: childToolColor,
        size: 11,
        style: {
          marginLeft: "auto"
        }
      })), childIsExpanded && canExpand && (() => {
        // Check if this child is a tool section that can be matched
        const isChildToolSection = TOOL_SECTION_TYPES.has(child.type) || child.type?.startsWith("mcp_");
        if (isChildToolSection) {
          const matchedChildFnDetail = child.matchedFnDetail;
          if (matchedChildFnDetail) {
            const themeColors = {
              primary: childToolColor,
              font_color: currentTheme?.theme?.font_color,
              darkGrey: currentTheme?.theme?.darkGrey,
              lightGrey: currentTheme?.theme?.lightGrey,
              mediumGrey: currentTheme?.theme?.mediumGrey
            };
            return /*#__PURE__*/React__default.createElement("div", {
              style: {
                padding: "6px 8px",
                fontFamily: "normalFont"
              }
            }, /*#__PURE__*/React__default.createElement(ToolCallDetail, {
              fnDetail: matchedChildFnDetail,
              themeColors: themeColors,
              accentColor: childToolColor,
              isStreaming: childIsStreaming
            }));
          }
        }

        // Default fallback for children
        return /*#__PURE__*/React__default.createElement("div", {
          className: "markdown-body",
          style: {
            ...markdownStyle,
            padding: 8,
            fontFamily: "normalFont",
            marginTop: 0,
            paddingTop: 0
          },
          dangerouslySetInnerHTML: {
            __html: md.render(preprocessCitations(child.text))
          }
        });
      })());
    })) : section.type === "citations" ? /*#__PURE__*/React__default.createElement("div", {
      style: {
        padding: 12,
        fontFamily: "normalFont"
      }
    }, (() => {
      const lines = section.text.split("\n").filter(line => line.trim());

      // Count citation occurrences in the full content (excluding citations section)
      const contentSectionsText = contentSections.filter(s => s.type === "content").map(s => s.text).join(" ");
      const getCitationCount = num => {
        const regex = new RegExp(`\\[\\^${num}\\]`, "g");
        const matches = contentSectionsText.match(regex);
        return matches ? matches.length : 0;
      };
      return lines.map((line, idx) => {
        // Parse lines like: [^1]: [title](url) or [^1]: url
        const footnoteMatch = line.match(/^\[\^(\d+)\]:\s*(?:\[([^\]]*)\]\(([^)]+)\)|(.+))$/);
        if (!footnoteMatch) return null;
        const citationNum = footnoteMatch[1];
        const title = footnoteMatch[2] || footnoteMatch[4] || `Source ${citationNum}`;
        const url = footnoteMatch[3] || footnoteMatch[4];
        const citationCount = getCitationCount(citationNum);

        // Get source data from sources prop if available
        const sourceData = citationMap.get(parseInt(citationNum, 10));
        const passage = sourceData?.passage || sourceData?.snippet || null;

        // Try to extract domain for display
        let domain = "";
        try {
          if (url && url.startsWith("http")) {
            const urlObj = new URL(url);
            domain = urlObj.hostname.replace("www.", "");
          }
        } catch (e) {}
        return /*#__PURE__*/React__default.createElement("div", {
          key: idx,
          id: `citation-ref-${citationNum}`,
          style: {
            display: "flex",
            alignItems: "flex-start",
            padding: "10px 0",
            borderBottom: idx < lines.length - 1 ? `0.5px solid ${currentTheme?.theme?.lightGrey || "#e5e7eb"}` : "none"
          }
        }, /*#__PURE__*/React__default.createElement("span", {
          style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 22,
            height: 17,
            fontSize: 11,
            fontWeight: 600,
            color: toolColor,
            background: `${toolColor}1a`,
            borderRadius: 4
          }
        }, citationNum), /*#__PURE__*/React__default.createElement("div", {
          style: {
            flex: 1,
            minWidth: 0
          }
        }, /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 8
          }
        }, /*#__PURE__*/React__default.createElement("a", {
          href: url,
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            fontSize: 13,
            fontWeight: 500,
            color: currentTheme?.theme?.font_color || "inherit",
            textDecoration: "none",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1
          },
          onMouseEnter: e => e.target.style.color = toolColor,
          onMouseLeave: e => e.target.style.color = currentTheme?.theme?.font_color || "inherit"
        }, domain || title), citationCount > 0 && /*#__PURE__*/React__default.createElement("span", {
          style: {
            fontSize: 10,
            fontWeight: 500,
            color: currentTheme?.theme?.darkGrey || "#6b7280",
            background: currentTheme?.theme?.lightGrey || "#f3f4f6",
            padding: "2px 6px",
            borderRadius: 10,
            whiteSpace: "nowrap"
          }
        }, citationCount, "\xD7")), /*#__PURE__*/React__default.createElement("span", {
          style: {
            fontSize: 11,
            color: currentTheme?.theme?.darkGrey || "#6b7280",
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            marginTop: 2
          }
        }, url), passage && /*#__PURE__*/React__default.createElement("div", {
          style: {
            fontSize: 12,
            lineHeight: 1.4,
            color: currentTheme?.theme?.darkGrey || "#6b7280",
            background: currentTheme?.theme?.lightGrey || "#f9fafb",
            borderLeft: `2px solid ${toolColor}`,
            padding: "6px 10px",
            marginTop: 8,
            borderRadius: "0 4px 4px 0",
            maxHeight: 60,
            overflow: "hidden"
          }
        }, passage.length > 150 ? `${passage.substring(0, 150)}...` : passage)), /*#__PURE__*/React__default.createElement(AppIcon, {
          icon: AppAssets?.icons?.arrow_right,
          color: currentTheme?.theme?.orange || "#6b7280",
          size: 14,
          isClickable: true,
          onPress: () => {
            if (sourceData) {
              // Open popover with source details
              const fakeEvent = {
                preventDefault: () => {},
                stopPropagation: () => {},
                target: {
                  getBoundingClientRect: () => ({
                    bottom: window.innerHeight / 2,
                    left: window.innerWidth / 2
                  })
                }
              };
              handleCitationClick(fakeEvent, parseInt(citationNum, 10));
            } else {
              // Fallback: open URL in new tab
              window.open(url, "_blank");
            }
          }
        }));
      });
    })()) : (() => {
      // Check if this is a tool section that can be matched to fnDetails
      const isToolSection = TOOL_SECTION_TYPES.has(section.type) || section.type?.startsWith("mcp_");
      if (isToolSection) {
        const matchedFnDetail = section.matchedFnDetail;
        if (matchedFnDetail) {
          const themeColors = {
            primary: toolColor,
            font_color: currentTheme?.theme?.font_color,
            darkGrey: currentTheme?.theme?.darkGrey,
            lightGrey: currentTheme?.theme?.lightGrey,
            mediumGrey: currentTheme?.theme?.mediumGrey
          };
          return /*#__PURE__*/React__default.createElement("div", {
            style: {
              padding: "8px 10px",
              fontFamily: "normalFont"
            }
          }, /*#__PURE__*/React__default.createElement(ToolCallDetail, {
            fnDetail: matchedFnDetail,
            themeColors: themeColors,
            accentColor: toolColor,
            isStreaming: isStreaming
          }));
        }

        // fnDetails available but no match, or still loading
        if (isLoadingFnDetails) {
          return /*#__PURE__*/React__default.createElement("div", {
            style: {
              padding: 12,
              fontFamily: "normalFont",
              fontSize: 12,
              color: currentTheme?.theme?.darkGrey,
              fontStyle: "italic"
            }
          }, "Loading tool details...");
        }
      }

      // Default fallback: render markdown text
      return /*#__PURE__*/React__default.createElement("div", {
        className: "markdown-body",
        style: {
          ...markdownStyle,
          padding: 12,
          fontFamily: "normalFont",
          marginTop: 0,
          paddingTop: 0
        },
        dangerouslySetInnerHTML: {
          __html: md.render(preprocessCitations(section.text))
        }
      });
    })())), showInProgressWithStyle && isMessageStreaming && index === contentSections.length - 1 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        marginTop: 8,
        height: 40
      }
    }, /*#__PURE__*/React__default.createElement(TypingText, {
      style: {
        fontSize: currentTheme?.theme?.small_font_size
      },
      textToDisplay: "",
      showOnlyIndicator: !processingStatus,
      useRotatingWords: !!processingStatus,
      processing_status: processingStatus,
      agentColor: agentColor,
      kaleidoscopeSize: 10,
      isStreaming: isMessageStreaming
    })));
  })) : (hasLongReasoning || hasDeepSearch) && !hideReasoning ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      paddingTop: 20
    },
    className: "reasoning-container"
  }, hasDeepSearch && deepSearchContent && /*#__PURE__*/React__default.createElement(AppText, {
    color: currentTheme?.theme?.primary,
    rightIconColor: currentTheme?.theme?.primary,
    wrapperStyle: {
      width: "fit-content",
      paddingTop: isInWidget ? 0 : 20,
      paddingBottom: 10
    },
    style: {
      textDecorationColor: currentTheme?.theme?.primary,
      fontWeight: "bold",
      marginLeft: 5
    },
    leftIcon: isMessageStreaming && !deepSearchStopped ? AppAssets?.icons?.web : AppAssets?.icons?.web,
    iconSize: 14,
    rightIcon: !isDeepSearchExpanded ? AppAssets?.icons?.expandReasoning : AppAssets?.icons?.collapseReasoning,
    isClickable: true,
    onPress: toggleDeepSearchExpand
  }, getDeepSearchText()), restOfContent && /*#__PURE__*/React__default.createElement(AppText, {
    color: currentTheme?.theme?.orange,
    rightIconColor: currentTheme?.theme?.orange,
    wrapperStyle: {
      width: "fit-content",
      paddingTop: isInWidget ? 0 : hasDeepSearch ? 0 : 20,
      paddingBottom: 10
    },
    style: {
      textDecorationColor: currentTheme?.theme?.orange,
      fontWeight: "bold",
      marginLeft: 5
    },
    leftIcon: isMessageStreaming || !thinkingStopped ? AppAssets?.icons?.reasoning : AppAssets?.icons?.thoughts,
    iconSize: 14,
    rightIcon: !hideReasoning ? null : !isExpanded ? AppAssets?.icons?.expandReasoning : AppAssets?.icons?.collapseReasoning,
    isClickable: hideReasoning,
    onPress: toggleExpand
  }, getReasoningText(), (isMessageStreaming || !thinkingStopped) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "inline-block",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      background: currentTheme?.theme?.orange,
      marginLeft: "8px",
      animation: "pulse 1.5s ease-in-out infinite"
    }
  })), contentSections.length > 0 ? /*#__PURE__*/React__default.createElement("div", null, contentSections.map((section, index) => /*#__PURE__*/React__default.createElement("div", {
    key: index
  }, section.type === "deep_search" && (hideReasoning || isDeepSearchExpanded) && /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: {
      ...markdownStyle,
      borderRadius: 0,
      borderWidth: 1,
      borderStyle: "solid",
      padding: 10,
      marginTop: 10,
      borderLeftColor: currentTheme?.theme?.primary,
      borderRightColor: currentTheme?.theme?.transparent,
      borderTopColor: currentTheme?.theme?.transparent,
      borderBottomColor: currentTheme?.theme?.transparent
    },
    dangerouslySetInnerHTML: {
      __html: md.render(preprocessCitations(section.text))
    }
  }), section.type === "thinking" && hideReasoning && /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: {
      ...markdownStyle,
      borderRadius: 0,
      borderWidth: 1,
      borderStyle: "solid",
      padding: 10,
      marginTop: 10,
      borderLeftColor: currentTheme?.theme?.orange,
      borderRightColor: currentTheme?.theme?.transparent,
      borderTopColor: currentTheme?.theme?.transparent,
      borderBottomColor: currentTheme?.theme?.transparent
    },
    dangerouslySetInnerHTML: {
      __html: md.render(preprocessCitations(section.text))
    }
  }), section.type === "content" && /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: {
      ...markdownStyle,
      marginTop: section.type === "content" && index > 0 ? 15 : 0
    },
    dangerouslySetInnerHTML: {
      __html: md.render(preprocessCitations(section.text))
    }
  })))) :
  /*#__PURE__*/
  /* Fallback to original behavior when sections are empty */
  React__default.createElement(React__default.Fragment, null, (hideReasoning || isExpanded) && /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: {
      ...markdownStyle,
      borderRadius: 0,
      borderWidth: 1,
      borderStyle: "solid",
      padding: 10,
      borderLeftColor: currentTheme?.theme?.orange,
      borderRightColor: currentTheme?.theme?.transparent,
      borderTopColor: currentTheme?.theme?.transparent,
      borderBottomColor: currentTheme?.theme?.transparent
    },
    dangerouslySetInnerHTML: {
      __html: md.render(preprocessCitations(restOfContent))
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: isExpanded && 15,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      maxWidth: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: markdownStyle,
    dangerouslySetInnerHTML: {
      __html: md.render(preprocessCitations(finalAnswer))
    }
  }), showInProgressWithStyle && isMessageStreaming && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 8,
      height: 40
    }
  }, /*#__PURE__*/React__default.createElement(TypingText, {
    style: {
      fontSize: currentTheme?.theme?.small_font_size
    },
    textToDisplay: "",
    showOnlyIndicator: !processingStatus && !useInterleavedReasoning,
    useRotatingWords: !!processingStatus || useInterleavedReasoning,
    processing_status: processingStatus,
    agentColor: agentColor,
    kaleidoscopeSize: 10,
    isStreaming: isMessageStreaming
  }))))) : /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      maxWidth: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "markdown-body",
    style: markdownStyle,
    ref: containerRef,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }), showInProgressWithStyle && isMessageStreaming && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: 8,
      height: 40
    }
  }, /*#__PURE__*/React__default.createElement(TypingText, {
    style: {
      fontSize: currentTheme?.theme?.small_font_size
    },
    textToDisplay: "",
    showOnlyIndicator: !processingStatus,
    useRotatingWords: !!processingStatus,
    processing_status: processingStatus,
    agentColor: agentColor,
    kaleidoscopeSize: 10,
    isStreaming: isMessageStreaming
  }))), renderHTMLLinkPreview && /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      marginTop: 10
    }
  }, links && links?.length > 0 && [...new Set(links)].map((link, index) => {
    if (index < 6) {
      return /*#__PURE__*/React__default.createElement(LinkPreview, {
        key: index,
        url: link
      });
    }
  })), activePopover && activePopover.source && /*#__PURE__*/React__default.createElement("div", {
    ref: popoverRef,
    className: `citation-popover ${mode}`,
    style: {
      top: activePopover.position.top,
      left: Math.min(activePopover.position.left, window.innerWidth - 420)
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "citation-close-btn",
    onClick: () => setActivePopover(null)
  }, "\xD7"), /*#__PURE__*/React__default.createElement("div", {
    className: "citation-popover-header"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: `citation-type-badge ${activePopover.source.type === "web" ? "web" : "document"}`
  }, activePopover.source.type === "web" ? "🌐 Web" : "📄 Document"), /*#__PURE__*/React__default.createElement("a", {
    href: activePopover.source.type === "web" ? activePopover.source.link : `/documents/${activePopover.source.documentId}`,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "citation-popover-title",
    title: activePopover.source.title
  }, activePopover.source.title)), /*#__PURE__*/React__default.createElement("div", {
    className: "citation-popover-body"
  }, /*#__PURE__*/React__default.createElement("blockquote", {
    className: "citation-passage"
  }, activePopover.source.type === "web" ? activePopover.source.snippet : activePopover.source.passage, activePopover.source.truncated && /*#__PURE__*/React__default.createElement("span", {
    className: "truncated-indicator"
  }, " ... (truncated)"))), activePopover.source.scoring && /*#__PURE__*/React__default.createElement("div", {
    className: "citation-popover-footer"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "citation-score"
  }, "Relevance: ", Math.round(activePopover.source.scoring * 100), "%"))));
};
MarkdownRenderer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MarkdownRenderer",
  "props": {
    "onCopy": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "renderHTMLinMarkdown": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "coder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "onPositiveFeedbackPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "onNegativeFeedbackPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "isSpeechGettingProcessed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "updateTextForSpeech": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "showTextToSpeech": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showCodeInExecution": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "renderDynamicHTML": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "renderHTMLLinkPreview": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "hideReasoning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "reasonedFor": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "isInWidget": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "showToolCallsDetailsInWidget": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "suppressCopyButton": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "suppressTextToSpeech": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "sources": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "onCitationClick": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "showInProgressWithStyle": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "processingStatus": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "agentColor": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "useInterleavedReasoning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "fnDetails": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    },
    "fnDetailsS3": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "toolCallout": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false
    },
    "agents": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    }
  }
};

const AppText = _ref => {
  let {
    children,
    style,
    color,
    fontWeight,
    width,
    textAlign,
    iconSize = 24,
    preventTranslation = false,
    rightIcon,
    leftIcon,
    wrapperStyle,
    onLeftIconPress,
    onRightIconPress,
    isClickable,
    onPress,
    trafficLightValue,
    isHoverable = isClickable,
    styleOnHover,
    isTextLeftAligned = false,
    emoji,
    leftIconStyle,
    iconHeight,
    iconWidth,
    numberOfLines,
    leftIconColor,
    rightIconColor,
    clickableViewWrapperStyle,
    renderMarkdown,
    showCopyButton = true,
    accessibilityLabel,
    markdownStyles = {},
    renderHTMLinMarkdown = true,
    showTextToSpeech = false,
    coder = false,
    customChartingConfig,
    S3downloadUrlRequest = () => {
      return "";
    },
    onCopy = () => {},
    workspaceid,
    copyIconColor,
    showFeedbackButtons,
    onPositiveFeedbackPress = () => {},
    onNegativeFeedbackPress = () => {},
    isSpeechGettingProcessed = false,
    updateTextForSpeech = () => {},
    showCodeInExecution = true,
    renderHTMLLinkPreview = true,
    hideReasoning = false,
    showTypingEffect = false,
    typingSpeed = 60,
    reasonedFor = null,
    isInWidget = false,
    showToolCallsDetailsInWidget = false,
    suppressCopyButton = false,
    suppressTextToSpeech = false,
    sources = [],
    onCitationClick = null,
    processingStatus = null,
    agentColor = null,
    useInterleavedReasoning = false,
    fnDetails = [],
    fnDetailsS3 = null,
    toolCallout = null,
    agents = [],
    ...props
  } = _ref;
  //@ts-ignore
  const {
    currentTheme
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [isMouseHover, setIsMouseHover] = useState(false);
  const [displayedText, setDisplayedText] = useState("");
  const typingIntervalRef = useRef(null);
  const typingCompleteRef = useRef(false);
  const styles = generateStyles({
    currentTheme,
    fontWeight,
    color,
    isClickable,
    isMouseHover,
    isHoverable,
    rightIcon
  });
  let coreText;
  useEffect(() => {
    // Clean up on unmount
    return () => {
      if (typingIntervalRef.current) {
        clearInterval(typingIntervalRef.current);
      }
    };
  }, []);
  useEffect(() => {
    if (!showTypingEffect || typeof children !== "string" || typingCompleteRef.current) {
      setDisplayedText(children);
      return;
    }

    // Reset when children changes
    setDisplayedText("");
    typingCompleteRef.current = false;
    if (typingIntervalRef.current) {
      clearInterval(typingIntervalRef.current);
    }
    const text = children;
    let currentIndex = 0;
    typingIntervalRef.current = setInterval(() => {
      if (currentIndex < text.length) {
        setDisplayedText(text.substring(0, currentIndex + 1));
        currentIndex++;
      } else {
        if (typingIntervalRef.current) {
          clearInterval(typingIntervalRef.current);
        }
        typingCompleteRef.current = true;
      }
    }, typingSpeed); // Adjust typing speed here (lower = faster)

    return () => {
      if (typingIntervalRef.current) {
        clearInterval(typingIntervalRef.current);
      }
    };
  }, [children, showTypingEffect]);
  if (renderMarkdown) {
    coreText = /*#__PURE__*/React__default.createElement(ScrollView, {
      contentInsetAdjustmentBehavior: "automatic",
      style: {
        height: "100%"
      }
    }, Platform.OS === "web" ? /*#__PURE__*/React__default.createElement(MarkdownRenderer, {
      renderHTMLinMarkdown: renderHTMLinMarkdown,
      coder: coder,
      showCodeInExecution: showCodeInExecution,
      hideReasoning: hideReasoning,
      renderHTMLLinkPreview: renderHTMLLinkPreview,
      copyIconColor: copyIconColor,
      S3downloadUrlRequest: S3downloadUrlRequest,
      workspaceid: workspaceid,
      showCopyButton: showCopyButton,
      markdownText: children,
      onCopy: onCopy,
      style: {
        color: currentTheme.theme?.font_color,
        fontSize: currentTheme?.theme?.small_font_size,
        fontFamily: "normalFont",
        ...markdownStyles
      },
      customChartingConfig: customChartingConfig,
      showFeedbackButtons: showFeedbackButtons,
      onPositiveFeedbackPress: onPositiveFeedbackPress,
      onNegativeFeedbackPress: onNegativeFeedbackPress,
      isSpeechGettingProcessed: isSpeechGettingProcessed,
      updateTextForSpeech: updateTextForSpeech,
      showTextToSpeech: showTextToSpeech,
      reasonedFor: reasonedFor,
      isInWidget: isInWidget,
      showToolCallsDetailsInWidget: showToolCallsDetailsInWidget,
      suppressCopyButton: suppressCopyButton,
      suppressTextToSpeech: suppressTextToSpeech,
      sources: sources,
      onCitationClick: onCitationClick,
      showInProgressWithStyle: !isInWidget,
      processingStatus: processingStatus,
      agentColor: agentColor,
      useInterleavedReasoning: useInterleavedReasoning,
      fnDetails: fnDetails,
      fnDetailsS3: fnDetailsS3,
      toolCallout: toolCallout,
      agents: agents
    }) : /*#__PURE__*/React__default.createElement(Markdown, {
      style: {
        body: {
          color: currentTheme.theme?.font_color,
          fontSize: currentTheme?.theme?.small_font_size,
          fontFamily: "normalFont",
          ...markdownStyles
        }
      }
    }, children));
  } else {
    const safeTranslate = text => {
      if (preventTranslation) {
        return text;
      }
      try {
        const textToTranslate = showTypingEffect && typeof text === "string" ? displayedText : text;
        if (typeof textToTranslate !== "string") {
          return textToTranslate;
        }
        if (textToTranslate.includes(":") || textToTranslate.includes("{") || textToTranslate.includes("}") || textToTranslate.includes("@") || textToTranslate.includes("|") || textToTranslate.includes("$")) {
          const escapedText = textToTranslate.replace(/:/g, "\\:").replace(/{/g, "\\{").replace(/}/g, "\\}").replace(/@/g, "\\@").replace(/\|/g, "\\|").replace(/\$/g, "\\$");
          const translated = t(escapedText);
          if (translated === escapedText) {
            return textToTranslate;
          }
          return translated;
        }
        const translated = t(textToTranslate);
        if (translated === textToTranslate) {
          return textToTranslate;
        }
        return translated;
      } catch (error) {
        if (showTypingEffect && typeof text === "string") {
          return displayedText;
        }
        return text;
      }
    };
    coreText = /*#__PURE__*/React__default.createElement(Text, _extends({}, props, {
      accessibilityLabel: accessibilityLabel,
      numberOfLines: numberOfLines,
      style: [styles.text, style]
    }), safeTranslate(children));
  }
  const coreTextComponent =
  /*#__PURE__*/
  //@ts-ignore
  React__default.createElement(View, {
    accessibilityLabel: accessibilityLabel,
    onMouseEnter: () => setIsMouseHover(true),
    onMouseLeave: () => setIsMouseHover(false),
    style: [styles.container, wrapperStyle, {
      cursor: isClickable && "pointer"
    }]
  }, leftIcon && /*#__PURE__*/React__default.createElement(View, {
    accessibilityLabel: accessibilityLabel,
    style: {
      flexDirection: "row",
      width: iconSize
    }
  }, /*#__PURE__*/React__default.createElement(AppIcon
  // Remove this when AppIcon has been converted to typescript
  //@ts-ignore
  , {
    accessibilityLabel: accessibilityLabel,
    style: [styles.leftIcon, leftIconStyle],
    size: iconSize,
    emoji: emoji,
    icon: leftIcon,
    color: leftIconColor || color,
    height: iconHeight,
    width: iconWidth,
    isClickable: !!onLeftIconPress,
    onPress: onLeftIconPress
  }), trafficLightValue && /*#__PURE__*/React__default.createElement(AppDot, {
    forcedValue: trafficLightValue
  })), isTextLeftAligned ? /*#__PURE__*/React__default.createElement(View, {
    accessibilityLabel: accessibilityLabel,
    style: {
      flexDirection: "row",
      flex: 1
    }
  }, coreText) : coreText, rightIcon && /*#__PURE__*/React__default.createElement(AppIcon
  // Remove this when AppIcon has been converted to typescript
  //@ts-ignore
  , {
    style: {
      alignSelf: "center",
      marginLeft: 5,
      alignItems: "flex-end"
    },
    size: iconSize,
    icon: rightIcon,
    color: rightIconColor || color,
    height: iconHeight,
    width: iconWidth,
    isClickable: !!onRightIconPress,
    onPress: onRightIconPress,
    accessibilityLabel: accessibilityLabel
  }));
  return isClickable ? /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    accessibilityLabel: accessibilityLabel,
    onPress: onPress,
    style: clickableViewWrapperStyle
  }, coreTextComponent) : coreTextComponent;
};

//@todo: use Pick to select the props from a base theme / interface

const generateStyles = _ref2 => {
  let {
    currentTheme,
    fontWeight,
    color,
    isMouseHover,
    isHoverable,
    rightIcon
  } = _ref2;
  return StyleSheet.create({
    leftIcon: {
      alignSelf: "center",
      marginRight: 5
    },
    container: {
      alignItems: "center",
      alignContent: "center",
      justifyContent: rightIcon ? "space-between" : "flex-start",
      flexDirection: "row"
    },
    text: {
      fontFamily: fontWeight && fontWeight !== "normal" ? "boldFont" : "normalFont",
      color: color || currentTheme?.theme?.font_color,
      fontSize: currentTheme?.theme?.small_font_size,
      textDecorationColor: currentTheme?.theme?.primary,
      textDecorationLine: isMouseHover && isHoverable ? "underline" : "none"
    }
  });
};
AppText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppText",
  "props": {
    "iconSize": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Size of the icon both left and right"
    },
    "preventTranslation": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true renders the text as is without translating"
    },
    "isHoverable": {
      "defaultValue": {
        "value": "isClickable",
        "computed": true
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the component shows an hover effect"
    },
    "isTextLeftAligned": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "Forces the text to be left aligned"
    },
    "showCopyButton": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "markdownStyles": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": ""
    },
    "renderHTMLinMarkdown": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "showTextToSpeech": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "coder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "S3downloadUrlRequest": {
      "defaultValue": {
        "value": "() => {\n  return \"\";\n}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(url: string) => string",
        "signature": {
          "arguments": [{
            "name": "url",
            "type": {
              "name": "string"
            }
          }],
          "return": {
            "name": "string"
          }
        }
      },
      "description": ""
    },
    "onCopy": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onPositiveFeedbackPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onNegativeFeedbackPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "isSpeechGettingProcessed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "updateTextForSpeech": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "showCodeInExecution": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "renderHTMLLinkPreview": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "hideReasoning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "showTypingEffect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "typingSpeed": {
      "defaultValue": {
        "value": "60",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "reasonedFor": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "isInWidget": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "showToolCallsDetailsInWidget": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "suppressCopyButton": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "suppressTextToSpeech": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "sources": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "any"
        }],
        "raw": "any[]"
      },
      "description": ""
    },
    "onCitationClick": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(source: any, citationNumber: number) => void",
        "signature": {
          "arguments": [{
            "name": "source",
            "type": {
              "name": "any"
            }
          }, {
            "name": "citationNumber",
            "type": {
              "name": "number"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "processingStatus": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "agentColor": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "useInterleavedReasoning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "fnDetails": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "any"
        }],
        "raw": "any[]"
      },
      "description": ""
    },
    "fnDetailsS3": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "object",
        "raw": "{ s3_key?: string; fn_count?: number }",
        "signature": {
          "properties": [{
            "key": "s3_key",
            "value": {
              "name": "string",
              "required": false
            }
          }, {
            "key": "fn_count",
            "value": {
              "name": "number",
              "required": false
            }
          }]
        }
      },
      "description": ""
    },
    "toolCallout": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": ""
    },
    "agents": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "any"
        }],
        "raw": "any[]"
      },
      "description": ""
    },
    "children": {
      "required": true,
      "tsType": {
        "name": "union",
        "raw": "string | TemplateStringsArray | (string | TemplateStringsArray)[]",
        "elements": [{
          "name": "string"
        }, {
          "name": "TemplateStringsArray"
        }, {
          "name": "Array",
          "elements": [{
            "name": "unknown"
          }],
          "raw": "(string | TemplateStringsArray)[]"
        }]
      },
      "description": "Text to display"
    },
    "style": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "TextStyle"
        }],
        "raw": "StyleProp<TextStyle>"
      },
      "description": "Style of the inner text"
    },
    "color": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Font color"
    },
    "fontWeight": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Whether the text will be displayed with normal or bold font"
    },
    "width": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Width of the overall component"
    },
    "textAlign": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Defines the direction in which the text is layed out"
    },
    "iconHeight": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Height of the icon both left and right"
    },
    "iconWidth": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Width of the icon both left and right"
    },
    "rightIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "When a fontawesome icon is passed, an icon to the right side is displayed"
    },
    "leftIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": "When a fontawesome icon is passed, an icon to the left side is displayed"
    },
    "wrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style of view wrapping all sub-components"
    },
    "onLeftIconPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event triggered when the left icon is clicked"
    },
    "onRightIconPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event triggered when the right icon is clicked"
    },
    "isClickable": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the component becomes clickable"
    },
    "onPress": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": "Event raised when the component is pressed - only applicable when the isClickable is set to true"
    },
    "trafficLightValue": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Dot displayed to the left side of the component to signify a notification hint - based on the value the colour changes from red to green"
    },
    "styleOnHover": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Style to apply when the component is hovered - only applicable when the isHoverable is set to true"
    },
    "emoji": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "When passed, it displays an emoji on the left hand side. All other props passed to the left icon can still be applied"
    },
    "leftIconStyle": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": "Style to apply to the left icon - both emoji and fontawesome"
    },
    "numberOfLines": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Defines how many times text can be wrapped"
    },
    "leftIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Color to apply to the left icon - both emoji and fontawesome"
    },
    "rightIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Color to apply to the right icon - both emoji and fontawesome"
    },
    "onLayout": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(event: LayoutChangeEvent) => void",
        "signature": {
          "arguments": [{
            "name": "event",
            "type": {
              "name": "LayoutChangeEvent"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "accessibilityLabel": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "clickableViewWrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style to apply when to the clickable component wrapping AppText when isClickable is set to true"
    },
    "renderMarkdown": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "workspaceid": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "copyIconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "customChartingConfig": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": ""
    },
    "showFeedbackButtons": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    }
  }
};

export { AppText as A, TypingText as T, AppIcon as a, stripForSpeech as s };
